(function () {
  'use strict';

  if (window.__MS_ORDER_WIZARD__) return;
  window.__MS_ORDER_WIZARD__ = true;

  var MAX_SONGS = 50;
  var PACKAGE_DISCOUNT = 0.2;

  var PLAYLIST_MAX_SONGS = {
    starter: 2,
    growth: 3,
    momentum: 5,
    impact: 7,
    scale: 12,
    dominance: 18,
    velocity: 24,
    ultimate: 35
  };

  var ALGORITHMIC_MAX_SONGS = {
    'basic-buzz': 1,
    'ultimate-impact': 2,
    elite: 3,
    platinum: 5,
    max: 7,
    global: 7
  };

  var EDITORIAL_MAX_SONGS = {
    'editorial-5k': 1,
    'editorial-15k': 2,
    'editorial-25k': 3,
    'editorial-35k': 4,
    'editorial-45k': 5
  };

  var PACKAGES = {
    playlist: [
      { id: 'starter', name: 'Starter', streams: '20K – 30K', price: 4500, desc: 'Perfect first step for debut singles.', maxSongs: 2 },
      { id: 'growth', name: 'Growth', streams: '50K – 60K', price: 8500, desc: 'Double the reach beyond your fanbase.', maxSongs: 3 },
      { id: 'momentum', name: 'Momentum', streams: '80K – 100K', price: 10900, desc: 'Sweet spot for breakout growth.', featured: true, maxSongs: 5 },
      { id: 'impact', name: 'Impact', streams: '150K – 200K', price: 19900, desc: 'Serious momentum for label-ready artists.', maxSongs: 7 },
      { id: 'scale', name: 'Scale', streams: '250K – 350K', price: 39900, desc: 'Built for EP and album rollouts.', maxSongs: 12 },
      { id: 'ultimate', name: 'Ultimate', streams: '1 Million', price: 119900, desc: 'The full push — 35 placements.', maxSongs: 35 }
    ],
    algorithmic: [
      { id: 'basic-buzz', name: 'Basic Buzz', streams: '5K – 10K', price: 12900, desc: 'Single track algorithmic push.', maxSongs: 1 },
      { id: 'ultimate-impact', name: 'Ultimate Impact', streams: '15K – 20K', price: 22900, desc: 'Trigger Spotify\'s recommendation engine.', maxSongs: 2 },
      { id: 'elite', name: 'Elite Visibility', streams: '25K – 30K', price: 32900, desc: 'Discover Weekly & Release Radar.', featured: true, maxSongs: 3 },
      { id: 'platinum', name: 'Platinum Push', streams: '35K – 40K', price: 42900, desc: 'Scale across multiple tracks.', maxSongs: 5 },
      { id: 'max', name: 'Max Exposure', streams: '45K – 50K', price: 52900, desc: 'Maximum algorithmic push.', maxSongs: 7 },
      { id: 'global', name: 'Global Reach', streams: '55K – 60K', price: 62900, desc: 'Largest algorithmic package.', maxSongs: 7 }
    ],
    editorial: [
      { id: 'editorial-5k', name: 'Spotify Editorial', streams: '5K – 10K', price: 7900, desc: 'Official editorial playlist placement.', fieldType: 'editorial', maxSongs: 1 },
      { id: 'editorial-15k', name: 'Spotify Editorial', streams: '15K – 20K', price: 15900, desc: 'Official editorial playlist placement.', fieldType: 'editorial', maxSongs: 2 },
      { id: 'editorial-25k', name: 'Spotify Editorial', streams: '25K – 30K', price: 24900, desc: 'Official editorial playlist placement.', fieldType: 'editorial', maxSongs: 3 },
      { id: 'editorial-35k', name: 'Spotify Editorial', streams: '35K – 40K', price: 34900, desc: 'Official editorial playlist placement.', fieldType: 'editorial', maxSongs: 4 },
      { id: 'editorial-45k', name: 'Spotify Editorial', streams: '45K – 50K', price: 49900, desc: 'Official editorial playlist placement.', fieldType: 'editorial', maxSongs: 5 },
      { id: 'radio', name: 'Spotify Radio', streams: '5K – 10K', price: 12900, desc: 'Appear on Spotify Radio.', fieldType: 'radio' }
    ],
    social: [
      { id: 'meta', name: 'Social Ads', streams: '3K – 5K', price: 4900, desc: 'Targeted Facebook and Instagram ad campaigns.', fieldType: 'meta' },
      { id: 'meta-8k', name: 'Social Ads', streams: '8K – 10K', price: 9900, desc: 'Scale Meta ads to reach more Spotify listeners.', fieldType: 'meta' },
      { id: 'meta-10k', name: 'Social Ads', streams: '10K – 20K', price: 14900, desc: 'Broader ad reach across Facebook and Instagram.', fieldType: 'meta' },
      { id: 'meta-25k', name: 'Social Ads', streams: '25K – 30K', price: 19900, desc: 'High-impact social ads for growing artists.', fieldType: 'meta', featured: true },
      { id: 'meta-40k', name: 'Social Ads', streams: '40K – 50K', price: 24900, desc: 'Serious ad spend for sustained listener growth.', fieldType: 'meta' },
      { id: 'meta-50k', name: 'Social Ads', streams: '50K – 75K', price: 49900, desc: 'Large-scale Meta campaigns for releases.', fieldType: 'meta' },
      { id: 'meta-100k', name: 'Social Ads', streams: '100K – 200K', price: 99900, desc: 'Major ad push for chart-minded campaigns.', fieldType: 'meta' },
      { id: 'meta-250k', name: 'Social Ads', streams: '250K – 500K', price: 129900, desc: 'Maximum social ad reach for major rollouts.', fieldType: 'meta' }
    ]
  };

  var PACKAGE_LIST_PRICES = (function () {
    var map = {};
    Object.keys(PACKAGES).forEach(function (category) {
      map[category] = {};
      PACKAGES[category].forEach(function (pkg) {
        map[category][pkg.id] = pkg.price;
      });
    });
    return map;
  })();

  var LEGACY_MORE_PACKAGES = {
    'algo-chart': { category: 'algorithmic', id: 'basic-buzz' },
    'algo-playlist': { category: 'algorithmic', id: 'basic-buzz' },
    'user-playlist': { category: 'playlist', id: 'starter' },
    radio: { category: 'editorial', id: 'radio' },
    meta: { category: 'social', id: 'meta' }
  };

  function formatSongLimitLabel(max, category) {
    if (!max) return '';
    if (category === 'playlist') return 'Up to ' + max + ' songs per playlist';
    if (max === 1) return '1 song link';
    return 'Up to ' + max + ' songs';
  }

  function getMaxSongs() {
    if (!state.package) return MAX_SONGS;
    if (state.package.maxSongs) return state.package.maxSongs;
    if (state.category === 'playlist' && PLAYLIST_MAX_SONGS[state.package.id]) {
      return PLAYLIST_MAX_SONGS[state.package.id];
    }
    if (state.category === 'algorithmic' && ALGORITHMIC_MAX_SONGS[state.package.id]) {
      return ALGORITHMIC_MAX_SONGS[state.package.id];
    }
    if (state.category === 'editorial' && EDITORIAL_MAX_SONGS[state.package.id]) {
      return EDITORIAL_MAX_SONGS[state.package.id];
    }
    return MAX_SONGS;
  }

  function isPerLinkPricing() {
    return state.category === 'social';
  }

  function hasPackageSongLimit() {
    if (!state.package || !state.category) return false;
    if (state.package.maxSongs) return true;
    if (state.category === 'playlist') return !!PLAYLIST_MAX_SONGS[state.package.id];
    if (state.category === 'algorithmic') return !!ALGORITHMIC_MAX_SONGS[state.package.id];
    if (state.category === 'editorial') return !!EDITORIAL_MAX_SONGS[state.package.id];
    return false;
  }

  function getSongsPerOrderLimit() {
    if (!hasPackageSongLimit()) return 0;
    return getMaxSongs();
  }

  function isExcessSongIndex(index) {
    var perOrder = getSongsPerOrderLimit();
    if (!perOrder) return false;
    return index >= perOrder;
  }

  function getExcessSongCount() {
    var perOrder = getSongsPerOrderLimit();
    if (!perOrder) return 0;
    return Math.max(0, state.songs.length - perOrder);
  }

  function getAddonSongCount() {
    return getExcessSongCount();
  }

  function isAddonSongIndex(index) {
    return isExcessSongIndex(index);
  }

  function calcAddonListPricePerSong() {
    var limit = getSongsPerOrderLimit();
    if (!limit || !state.package) return 0;
    var unitDollars = calcUnitPrice() / 100;
    return Math.round((unitDollars / limit) * 1.10) * 100;
  }

  function calcAddonPricePerSong() {
    if (!state.package) return 0;
    return Math.round(calcAddonListPricePerSong() * (1 - PACKAGE_DISCOUNT));
  }

  function calcAddonListChargesTotal() {
    return getAddonSongCount() * calcAddonListPricePerSong();
  }

  function calcAddonChargesTotal() {
    return getAddonSongCount() * calcAddonPricePerSong();
  }

  function calcPackageListPrice() {
    if (!state.package) return 0;
    var unit = Math.round(calcUnitPrice());
    if (isPerLinkPricing()) {
      return unit * state.songs.length;
    }
    return unit;
  }

  function calcPackageBaseTotal() {
    if (!state.package) return 0;
    return Math.round(calcPackageListPrice() * (1 - PACKAGE_DISCOUNT));
  }

  function calcPackageDiscountAmount() {
    if (!state.package) return 0;
    return Math.max(0, calcPackageListPrice() - calcPackageBaseTotal());
  }

  function getPackageDiscountPercent() {
    return Math.round(PACKAGE_DISCOUNT * 100);
  }

  function hasStandardPackageDiscount(listPriceCents) {
    return PACKAGE_DISCOUNT > 0 && listPriceCents > 0;
  }

  function calcDiscountedListPrice(listPriceCents) {
    return Math.round(listPriceCents * (1 - PACKAGE_DISCOUNT));
  }

  function buildPackageDiscountBadgeHtml() {
    if (PACKAGE_DISCOUNT <= 0) return '';
    return '<span class="package-option__discount-badge">' + getPackageDiscountPercent() + '% OFF</span>';
  }

  function buildPackagePriceHtml(listPriceCents, options) {
    options = options || {};
    var perLinkSuffix = options.perLink ? ' / link' : '';
    if (!hasStandardPackageDiscount(listPriceCents)) {
      return '<span class="package-option__price-amount">' + money(listPriceCents) + perLinkSuffix + '</span>';
    }
    return (
      '<span class="package-option__price-value">' +
        '<span class="package-option__price-compare">' + money(listPriceCents) + '</span>' +
        '<span class="package-option__price-amount">' + money(calcDiscountedListPrice(listPriceCents)) + perLinkSuffix + '</span>' +
      '</span>'
    );
  }

  function buildSongCardDiscountBadgeHtml() {
    if (PACKAGE_DISCOUNT <= 0) return '';
    return '<span class="song-card__art-discount">' + getPackageDiscountPercent() + '% off</span>';
  }

  function buildSongCardArtHtml(song, isIncluded, isAddon) {
    var artInner = song.art
      ? '<img class="song-card__art" src="' + escapeHtml(song.art) + '" alt="">'
      : '<div class="song-card__art song-card__art--placeholder"><i class="ti ti-music"></i></div>';
    var statusBadge = isIncluded
      ? '<span class="song-card__art-badge song-card__art-badge--included">Included</span>'
      : (isAddon ? '<span class="song-card__art-badge song-card__art-badge--excess">Add-on</span>' : '');
    return (
      '<div class="song-card__art-wrap">' +
        artInner +
        statusBadge +
        buildSongCardDiscountBadgeHtml() +
      '</div>'
    );
  }

  function calcOrderSubtotalBeforeCoupon() {
    if (!state.package) return 0;
    return (calcPackageBaseTotal() + calcAddonChargesTotal()) * getOrderQty();
  }

  function canProceedToStep4() {
    return state.songs.length > 0;
  }

  function removeExcessSongs() {
    var limit = getSongsPerOrderLimit();
    if (!limit || state.songs.length <= limit) return;
    state.songs = state.songs.slice(0, limit);
    if (summaryTrackIndex >= state.songs.length) {
      summaryTrackIndex = Math.max(0, state.songs.length - 1);
    }
    renderSongs();
    updatePromoteBtn();
    updateSummary();
    showToast('Removed additional songs. Your selection now fits the package.');
  }

  function promptForSongsBeforeCheckout() {
    showToast('Select at least one song before continuing.');
    goToStep(1);
    if (songSearch) {
      setTimeout(function () {
        songSearch.focus();
        songSearch.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 300);
    }
  }

  function updateSongLimitHint() {
    var hints = document.querySelectorAll('.song-board__hint');
    if (!hints.length) return;
    var max = getMaxSongs();
    var limitText = isPerLinkPricing()
      ? 'Priced per link · total updates with each track you add'
      : hasPackageSongLimit()
        ? (max === 1
          ? '1 song per order · see warning if you add more'
          : 'Up to ' + max + ' songs per order · see warning if you add more')
        : 'Up to ' + max + ' tracks';
    hints.forEach(function (el) {
      if (el.classList.contains('song-board__hint--desktop')) {
        el.innerHTML = '<kbd>Enter</kbd> to add · Album links add all songs · ' + limitText;
      } else if (el.classList.contains('song-board__hint--mobile')) {
        el.textContent = 'Tap Add or pick from search · Album links add all songs · ' + limitText;
      }
    });
  }

  function resolveOrderCategory(category, packageId) {
    if (category === 'more') {
      if (packageId && packageId.indexOf('editorial') === 0) return 'editorial';
      if (packageId && LEGACY_MORE_PACKAGES[packageId]) return LEGACY_MORE_PACKAGES[packageId].category;
      if (packageId === 'meta') return 'social';
      return 'editorial';
    }
    return category;
  }

  function resolveOrderPackage(category, packageId) {
    if (category === 'more' && packageId && LEGACY_MORE_PACKAGES[packageId]) {
      return LEGACY_MORE_PACKAGES[packageId].id;
    }
    return packageId;
  }

  function getPackagesForCategory(category) {
    return PACKAGES[category] || [];
  }

  function getCanonicalPackagePrice(category, pkgId) {
    var categoryPrices = PACKAGE_LIST_PRICES[category];
    if (!categoryPrices || categoryPrices[pkgId] == null) return null;
    return categoryPrices[pkgId];
  }

  function applyCanonicalPackagePrice(pkg) {
    if (!pkg || !state.category) return pkg;
    var listPrice = getCanonicalPackagePrice(state.category, pkg.id);
    if (listPrice != null) pkg.price = listPrice;
    return pkg;
  }

  function getLowestPackageForCategory(category) {
    var list = getPackagesForCategory(category);
    if (!list.length) return null;
    return list.reduce(function (lowest, pkg) {
      if (!lowest || pkg.price < lowest.price) return pkg;
      return lowest;
    }, null);
  }

  function syncPackageCatalogPrice() {
    if (!state.package || !state.category) return;
    if (state.category === 'editorial' || state.category === 'social') {
      applyCanonicalPackagePrice(state.package);
      return;
    }
    var synced = catalogUnitPrice(state.category, state.package.id);
    if (synced != null) state.package.price = synced;
  }

  function invalidateCheckoutFieldsIfNeeded() {
    if (state.step !== 4 && dynamicFields) {
      dynamicFields.innerHTML = '';
    }
  }

  function refreshOrderAfterSelectionChange(options) {
    options = options || {};
    syncPackageCatalogPrice();
    invalidateCheckoutFieldsIfNeeded();
    if (options.rerenderCategories) renderCategories();
    if (options.rerenderPackages !== false) renderPackages();
    updateSongLimitHint();
    renderSongs();
    if (state.step === 4) renderFields();
    updateSummary();
  }

  function applyDefaultSelection() {
    if (!state.category) {
      state.category = 'playlist';
    }
    if (!state.package) {
      state.package = getLowestPackageForCategory(state.category);
      applyCanonicalPackagePrice(state.package);
    }
    refreshOrderAfterSelectionChange({ rerenderCategories: true });
  }

  var CATEGORIES = {
    playlist: {
      label: 'Spotify Playlist Campaign',
      icon: 'ti-playlist',
      from: '$45',
      featured: true,
      tagline: 'Curator playlists',
      desc: 'Real curator playlist placements. Build saves, followers, and steady listener growth.',
      perks: ['20K–1M streams', 'Verified curators', '100% organic']
    },
    algorithmic: {
      label: 'Spotify Algorithmic Campaign',
      icon: 'ti-chart-arrows-vertical',
      from: '$129',
      tagline: 'Spotify algorithm',
      desc: 'Trigger Discover Weekly, Release Radar, and Spotify\'s recommendation engine.',
      perks: ['Algo playlists', 'Chart momentum', 'Royalty-eligible']
    },
    editorial: {
      label: 'Spotify Editorial Campaign',
      icon: 'ti-article',
      from: '$79',
      tagline: 'Official playlists',
      desc: 'Earn placement on Spotify editorial playlists — the highest-visibility spots on the platform.',
      perks: ['Editorial placement', 'Spotify Radio', 'Royalty-eligible']
    },
    social: {
      label: 'Social Media Ads Campaign',
      icon: 'ti-brand-meta',
      from: '$49',
      tagline: 'Facebook · Instagram',
      desc: 'Run targeted Facebook and Instagram ad campaigns that drive real Spotify listeners.',
      perks: ['Meta ads', 'Geo targeting', 'Real listeners']
    }
  };

  var MOCK_TRACKS = [
    { title: 'Midnight Drive', artist: 'Nova Ray', art: 'https://i.scdn.co/image/ab67616d0000b273c8a11e48c91a982d086afcda' },
    { title: 'Golden Hour', artist: 'The Echoes', art: 'https://i.scdn.co/image/ab67616d0000b273bb54dde68cdad2301204540' },
    { title: 'Neon Skies', artist: 'Kira Bloom', art: 'https://i.scdn.co/image/ab67616d0000b273d9194aa18fa581c7d546fe2' },
    { title: 'Lost in Sound', artist: 'DJ Meridian', art: 'https://i.scdn.co/image/ab67616d0000b273f7b717b9aee4086243f6d63d' }
  ];

  var state = {
    step: 1,
    songs: [],
    category: null,
    package: null,
    quantity: 1,
    appliedCouponCode: null,
    couponUserRemoved: false,
    cartPricing: null
  };

  var cartSyncTimer = null;
  var cartSyncPromise = null;

  var panels = document.querySelectorAll('.order-panel');
  var steps = document.querySelectorAll('.order-step');
  var btnAddSong = document.getElementById('btnAddSong');
  var songRow = document.getElementById('songRow');
  var songEmpty = document.getElementById('songEmpty');
  var songTracksWrap = document.getElementById('songTracksWrap');
  var songCount = document.getElementById('songCount');
  var songTracksIncludedBadge = document.getElementById('songTracksIncludedBadge');
  var songLimitWarning = document.getElementById('songLimitWarning');
  var songLimitAllowed = document.getElementById('songLimitAllowed');
  var songLimitSelected = document.getElementById('songLimitSelected');
  var songLimitAdditional = document.getElementById('songLimitAdditional');
  var songLimitNote = document.getElementById('songLimitNote');
  var btnRemoveExcessSongs = document.getElementById('btnRemoveExcessSongs');
  var songSearch = document.getElementById('songSearch');
  var songSearchResults = document.getElementById('songSearchResults');
  var songSearchError = document.getElementById('songSearchError');
  var btnPromoteSongs = document.getElementById('btnPromoteSongs');
  var btnPromoteLabel = document.getElementById('btnPromoteLabel');
  var step1Help = document.getElementById('step1Help');
  var btnFocusSearch = document.getElementById('btnFocusSearch');
  var orderProgressFill = document.getElementById('orderProgressFill');
  var orderToast = document.getElementById('orderToast');
  var categoryGrid = document.getElementById('categoryGrid');
  var packageGrid = document.getElementById('packageGrid');
  var dynamicFields = document.getElementById('dynamicFields');
  var orderSummary = document.getElementById('orderSummary');
  var orderSummaryPanel = document.getElementById('orderSummaryPanel');
  var orderSummaryToggleTotal = document.getElementById('orderSummaryToggleTotal');
  var orderTotal = document.getElementById('orderTotal');
  var qtyInput = document.getElementById('orderQuantity');
  var toastTimer = null;
  var searchDebounce = null;
  var searchRequestId = 0;
  var spotifyApi = typeof spotifyClient !== 'undefined' ? spotifyClient : null;
  var orderSubmitHelp = document.getElementById('orderSubmitHelp');
  var orderCatalog = null;
  var summaryTrackIndex = 0;
  var summaryStackSongCount = 0;

  var DEFAULT_SONG_ART = 'data:image/svg+xml,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">' +
      '<defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">' +
        '<stop offset="0%" stop-color="#f5f2ec"/><stop offset="100%" stop-color="#e8e4dc"/>' +
      '</linearGradient></defs>' +
      '<rect width="400" height="400" fill="url(#g)"/>' +
      '<circle cx="200" cy="200" r="72" fill="none" stroke="#c8c4bc" stroke-width="6" opacity="0.55"/>' +
      '<path d="M178 148v104l78-52z" fill="#a8a49c" opacity="0.75"/>' +
    '</svg>'
  );

  function stackLayerRotation(layerFromFront) {
    return layerFromFront % 2 === 1 ? -5 : 5;
  }

  var SUMMARY_PLAY_ICON =
    '<svg class="summary-stack__play-svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
      '<path d="M8 5.14v13.72c0 .79.87 1.27 1.54.84l11.14-6.86c.6-.37.6-1.27 0-1.64L9.54 4.3A1 1 0 0 0 8 5.14z" fill="currentColor"/>' +
    '</svg>';

  try {
    var catalogEl = document.getElementById('orderCatalog');
    if (catalogEl) orderCatalog = JSON.parse(catalogEl.textContent);
  } catch (err) {
    orderCatalog = null;
  }

  function getPackageHandle() {
    if (!orderCatalog || !state.package || !state.category) return null;
    var map = orderCatalog.packages[state.category];
    return map ? map[state.package.id] : null;
  }

  function variantListPriceCents(variant) {
    if (!variant) return 0;
    if (variant.listPrice) return variant.listPrice;
    return variant.price;
  }

  function catalogUnitPrice(category, pkgId) {
    if (category === 'editorial' || category === 'social') {
      return getCanonicalPackagePrice(category, pkgId);
    }
    if (!orderCatalog) return null;
    var handle = orderCatalog.packages[category] && orderCatalog.packages[category][pkgId];
    var product = handle && orderCatalog.products[handle];
    if (!product || !product.variants.length) return null;
    return variantListPriceCents(product.variants[0]);
  }

  function getProductForPackage() {
    var handle = getPackageHandle();
    if (!handle || !orderCatalog || !orderCatalog.products[handle]) return null;
    return orderCatalog.products[handle];
  }

  function findVariantForListPrice(product, listPriceCents) {
    if (!product || !product.variants.length) return null;
    var discounted = Math.round(listPriceCents * (1 - PACKAGE_DISCOUNT));
    return product.variants.find(function (v) { return v.price === discounted; }) ||
      product.variants.find(function (v) { return v.price === listPriceCents; }) ||
      product.variants.find(function (v) { return variantListPriceCents(v) === listPriceCents; }) ||
      product.variants[0];
  }

  function getSelectedVariant() {
    var product = getProductForPackage();
    if (!product) return null;

    if (state.category === 'playlist' && product.variants.length > 1) {
      var duration = document.getElementById('field-duration');
      if (duration && duration.value) {
        var selected = duration.selectedOptions[0];
        if (selected && selected.dataset.price) {
          return findVariantForListPrice(product, parseInt(selected.dataset.price, 10));
        }
        var titlePart = duration.value.split(' (')[0];
        return product.variants.find(function (v) { return v.title === titlePart; }) || product.variants[0];
      }
    }

    if (state.category === 'editorial' && state.package) {
      var listPrice = getCanonicalPackagePrice(state.category, state.package.id) || state.package.price;
      var editorialStreams = document.getElementById('field-editorialStreams');
      if (editorialStreams && editorialStreams.selectedOptions[0] && editorialStreams.selectedOptions[0].dataset.price) {
        listPrice = parseInt(editorialStreams.selectedOptions[0].dataset.price, 10) || listPrice;
      }
      return findVariantForListPrice(product, listPrice) || product.variants[0];
    }

    if (state.category === 'social' && state.package) {
      var socialListPrice = getCanonicalPackagePrice(state.category, state.package.id) || state.package.price;
      return findVariantForListPrice(product, socialListPrice) || product.variants[0];
    }

    return product.variants[0] || null;
  }

  function getVariantUnitPriceCents() {
    var variant = getSelectedVariant();
    if (variant) return variant.price;
    if (state.package && state.category) {
      var listPrice = getCanonicalPackagePrice(state.category, state.package.id) || state.package.price;
      return Math.round(listPrice * (1 - PACKAGE_DISCOUNT));
    }
    return calcPackageBaseTotal();
  }

  function getCheckoutAdjustmentVariant() {
    if (!orderCatalog) return null;

    if (orderCatalog.checkoutAdjustment &&
        orderCatalog.checkoutAdjustment.variantId &&
        isValidAdjustmentUnitCents(orderCatalog.checkoutAdjustment.unitCents)) {
      return {
        id: orderCatalog.checkoutAdjustment.variantId,
        price: orderCatalog.checkoutAdjustment.unitCents,
        title: orderCatalog.checkoutAdjustment.title || 'Checkout adjustment'
      };
    }

    var handle = orderCatalog.checkoutAdjustmentHandle || 'ms-song-addon';
    var product = orderCatalog.products[handle];
    if (!product || !product.variants.length) return null;

    var variant = product.variants.find(function (v) {
      return isValidAdjustmentUnitCents(v.price);
    });
    if (!variant) return null;

    return {
      id: variant.id,
      price: variant.price,
      title: product.title || 'Checkout adjustment'
    };
  }

  function isValidAdjustmentUnitCents(unitCents) {
    return unitCents === 1 || unitCents === 100;
  }

  function getAdjustmentQuantity(adjustmentCents, unitCents) {
    if (!adjustmentCents || adjustmentCents <= 0 || !isValidAdjustmentUnitCents(unitCents)) {
      return { qty: 0, drift: 0 };
    }
    if (unitCents === 1) {
      return { qty: adjustmentCents, drift: 0 };
    }
    var qty = Math.round(adjustmentCents / unitCents);
    if (qty <= 0) return { qty: 0, drift: adjustmentCents };
    return { qty: qty, drift: Math.abs((qty * unitCents) - adjustmentCents) };
  }

  function adjustmentCentsToQuantity(adjustmentCents, unitCents) {
    return getAdjustmentQuantity(adjustmentCents, unitCents).qty;
  }

  function getCheckoutAdjustmentVariantId() {
    var variant = getCheckoutAdjustmentVariant();
    return variant ? variant.id : null;
  }

  function getCheckoutAdjustmentSetupError(adjustmentCents) {
    if (!adjustmentCents || adjustmentCents <= 0) return '';
    var variant = getCheckoutAdjustmentVariant();
    if (!variant) {
      return 'Checkout add-ons are not configured. Add ms-song-addon ($0.01) to the order-wizard collection, or paste its variant ID in Theme settings → Order wizard.';
    }
    var adjustmentQty = getAdjustmentQuantity(adjustmentCents, variant.price);
    if (!adjustmentQty.qty) {
      return 'Checkout add-on amount is invalid for this order. Please contact support.';
    }
    if (variant.price === 100 && adjustmentQty.drift > 0) {
      return 'Checkout add-ons need exact cent pricing. Set ms-song-addon to $0.01 in Shopify Admin, or remove coupon codes and try again.';
    }
    return '';
  }

  function calcCheckoutAdjustmentCents(orderQty) {
    orderQty = orderQty || getOrderQty();
    var variantUnit = getVariantUnitPriceCents();
    var wizardTotal = calcOrderTotal();
    return Math.max(0, wizardTotal - (variantUnit * orderQty));
  }

  function needsCheckoutDiscountCode(orderQty) {
    orderQty = orderQty || getOrderQty();
    if (calcCheckoutAdjustmentCents(orderQty) > 0) return false;
    return calcOrderTotal() < (getVariantUnitPriceCents() * orderQty);
  }

  function getCheckoutRedirectUrl() {
    return '/checkout';
  }

  function normalizeCouponCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function isDiscountOnCart(cart, code) {
    var target = normalizeCouponCode(code);
    if (!cart || !target) return false;

    var apps = cart.cart_level_discount_applications || [];
    var i;
    for (i = 0; i < apps.length; i++) {
      if (normalizeCouponCode(apps[i].title || apps[i].code || '') === target) return true;
    }

    var codes = cart.discount_codes || [];
    for (i = 0; i < codes.length; i++) {
      var entry = codes[i];
      var entryCode = normalizeCouponCode(typeof entry === 'string' ? entry : (entry.code || entry.title || ''));
      if (entryCode === target) {
        if (entry && typeof entry === 'object' && entry.applicable === false) continue;
        return true;
      }
    }

    return false;
  }

  function validateShopifyDiscountCode(code) {
    code = normalizeCouponCode(code);
    if (!code) return Promise.resolve({ valid: false });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) return { valid: false };
          if (isDiscountOnCart(data, code)) return { valid: true };
          if (!data.item_count) return { valid: true, pending: true };
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (cartRes) { return cartRes.json(); })
            .then(function (fresh) {
              if (isDiscountOnCart(fresh, code)) return { valid: true };
              return { valid: false };
            });
        });
      })
      .catch(function () {
        return { valid: false };
      });
  }

  function applyCheckoutDiscounts() {
    var codes = [];
    var coupon = getEffectiveCoupon();
    if (coupon && coupon.shopify !== false) {
      codes.push(coupon.code);
    } else if (needsCheckoutDiscountCode()) {
      codes.push((orderCatalog && orderCatalog.checkoutDiscountCode) || 'MS20OFF');
    }
    if (!codes.length) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function clearCheckoutDiscount() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    }).catch(function () {});
  }

  function updateCartPricingFromCart(cart) {
    if (!cart || !state.appliedCouponCode) {
      state.cartPricing = null;
      return;
    }

    var offerSubtotal = window.MSCartPricing
      ? window.MSCartPricing.getCartSubtotalCents(cart)
      : calcOrderSubtotalBeforeCoupon();
    var shopifyDiscount = cart.total_discount || 0;
    var totalCents = cart.total_price || Math.max(0, offerSubtotal - shopifyDiscount);

    state.cartPricing = {
      offerSubtotalCents: offerSubtotal,
      shopifyDiscountCents: shopifyDiscount,
      totalCents: totalCents
    };
  }

  function syncWizardCartWithPricing() {
    if (!state.package || !getVariantId()) {
      return Promise.resolve(null);
    }

    var payload = buildCartItems();
    if (payload.error) {
      return Promise.reject(new Error(payload.error));
    }

    if (cartSyncPromise) return cartSyncPromise;

    cartSyncPromise = fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: payload.items })
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: collectCartAttributes() })
        });
      })
      .then(function () {
        return applyCheckoutDiscounts();
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartPricingFromCart(cart);
        document.dispatchEvent(new CustomEvent('theme:cart-updated', {
          detail: { cart: cart, source: 'wizard' }
        }));
        return cart;
      })
      .finally(function () {
        cartSyncPromise = null;
      });

    return cartSyncPromise;
  }

  function scheduleCartSync() {
    if (!state.appliedCouponCode || !state.package) return;
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(function () {
      syncWizardCartWithPricing()
        .then(function () {
          updateSummary({ skipCartSync: true });
        })
        .catch(function () {});
    }, 450);
  }

  function getVariantId() {
    var variant = getSelectedVariant();
    return variant ? variant.id : null;
  }

  function createBundleId() {
    return 'ms-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeSong(song) {
    if (!song) {
      return { id: '', title: '', artist: '', album: '', art: '', url: '' };
    }
    return {
      id: song.id || '',
      title: String(song.title || '').trim(),
      artist: String(song.artist || '').trim(),
      album: String(song.album || song.playlist || song.playlistName || '').trim(),
      art: String(song.art || song.artwork || song.image || '').trim(),
      url: String(song.url || '').trim()
    };
  }

  function bindSummaryArtFallback(img) {
    if (!img || img.dataset.fallbackBound) return;
    img.dataset.fallbackBound = '1';
    img.addEventListener('error', function () {
      img.onerror = null;
      img.src = DEFAULT_SONG_ART;
      img.classList.add('summary-stack__art--fallback');
      img.removeAttribute('alt');
      img.setAttribute('role', 'presentation');
    });
  }

  function adminPropName(label) {
    return String(label).replace(/\*+\?*$/g, '').replace(/\?+$/g, '').trim();
  }

  function sanitizePropertyValue(name, value) {
    value = String(value || '').trim();
    if (!value) return '';

    var lower = String(name).toLowerCase();
    if (lower.indexOf('social') !== -1) {
      if (value.indexOf('start-your-campaign') !== -1) return '';
      if (/^https?:\/\/[^/]*myshopify\.com\/?$/i.test(value)) return '';
    }
    if (lower === 'add notes') {
      if (/^(pages\/start-your-campaign\s*)+$/i.test(value.replace(/\s/g, ''))) return '';
      value = value.replace(/(pages\/start-your-campaign)+/gi, ' ').trim();
      if (/^(https?:\/\/[^\s]+\s*)+$/i.test(value)) {
        var urls = value.split(/\s+/).filter(Boolean);
        var unique = urls.filter(function (url, i) { return urls.indexOf(url) === i; });
        if (unique.length === 1 && unique[0].indexOf('myshopify.com') !== -1) return '';
        value = unique.join('\n');
      }
    }
    if (lower === 'add notes' && value.length > 500) value = value.slice(0, 500);
    return value;
  }

  function unicodeBold(text) {
    return String(text).replace(/[A-Za-z0-9]/g, function (ch) {
      var code = ch.charCodeAt(0);
      if (code >= 65 && code <= 90) return String.fromCodePoint(0x1D5D4 + (code - 65));
      if (code >= 97 && code <= 122) return String.fromCodePoint(0x1D5EE + (code - 97));
      if (code >= 48 && code <= 57) return String.fromCodePoint(0x1D7EC + (code - 48));
      return ch;
    });
  }

  function summaryRow(label, value) {
    var pad = 18;
    var plainKey = String(label).toUpperCase();
    if (plainKey.length > pad - 2) plainKey = plainKey.slice(0, pad - 3) + '.';
    var key = unicodeBold(plainKey) + ':';
    return key + (' '.repeat(Math.max(1, pad - plainKey.length))) + value;
  }

  function appendSharedSummaryLines(lines) {
    if (state.package) {
      lines.push(summaryRow('Package', state.package.name +
        (state.package.streams ? ' (' + state.package.streams + ')' : '')));
    }
    if (state.category) {
      lines.push(summaryRow('Category', CATEGORIES[state.category].label));
    }

    var orderQty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : (state.quantity || 1);
    if (orderQty > 1) {
      lines.push(summaryRow('Order quantity', String(orderQty)));
    }

    if (dynamicFields) {
      dynamicFields.querySelectorAll('input, select, textarea').forEach(function (field) {
        if (!field.name || !fieldIsVisible(field)) return;
        var val = sanitizePropertyValue(field.name, field.value);
        if (!val) return;
        lines.push(summaryRow(field.name, val));
      });
    }

    var coupon = getEffectiveCoupon();
    if (coupon) {
      lines.push(summaryRow('Coupon', coupon.code + ' — ' + coupon.label));
    }
  }

  function appendTrackSummaryLines(lines, tracks, startIndex) {
    if (!tracks.length) return;
    lines.push('');
    lines.push('--------------------------------------');
    lines.push(unicodeBold('TRACKS') + ': (' + tracks.length + ')');
    lines.push('--------------------------------------');
    tracks.forEach(function (s, i) {
      var globalIndex = startIndex + i;
      var addonNote = isAddonSongIndex(globalIndex) ? ' [Add-on]' : '';
      lines.push('');
      lines.push(unicodeBold(String(i + 1) + '.') + ' ' +
        (s.title || 'Unknown track') + (s.artist ? ' — ' + s.artist : '') + addonNote);
      if (s.url) lines.push('   ' + unicodeBold('Link') + ': ' + s.url);
      if (tracks.length > 1 && i < tracks.length - 1) {
        lines.push('----------------');
      }
    });
  }

  function buildCampaignSummary() {
    var lines = [
      '======================================',
      '   ' + unicodeBold('CAMPAIGN ORDER SUMMARY'),
      '======================================',
      ''
    ];

    appendSharedSummaryLines(lines);
    appendTrackSummaryLines(lines, state.songs, 0);

    var addonCount = getAddonSongCount();
    var addonPrice = calcAddonPricePerSong();
    var addonTotal = calcAddonChargesTotal();
    var orderQty = getOrderQty();

    lines.push('');
    var unitList = Math.round(calcUnitPrice());
    var packageSummary = isPerLinkPricing() && state.songs.length > 0
      ? state.songs.length + ' link' + (state.songs.length === 1 ? '' : 's') +
        ' × ' + money(unitList) + ' → ' + money(calcPackageBaseTotal()) + ' (20% off)'
      : money(calcPackageListPrice()) + ' → ' + money(calcPackageBaseTotal()) + ' (20% off)';
    lines.push(summaryRow(
      'Package',
      packageSummary + (orderQty > 1 ? ' × ' + orderQty : '')
    ));
    if (addonCount > 0) {
      lines.push(summaryRow(
        'Additional Song Add-ons',
        addonCount + ' × ' + money(calcAddonListPricePerSong()) + ' → ' +
          money(addonPrice) + ' (20% off) = ' + money(addonTotal) +
          (orderQty > 1 ? ' × ' + orderQty : '')
      ));
    }

    var discount = calcCouponDiscountAmount();
    if (discount > 0) {
      lines.push(summaryRow('Discount', '-' + money(discount)));
    }

    lines.push('');
    lines.push('======================================');
    var total = calcOrderTotal();
    if (total > 0) {
      lines.push(summaryRow('Total', money(total)));
    }
    return lines.join('\n');
  }

  function buildCartItems() {
    var variantId = getVariantId();
    if (!variantId) return { error: 'Could not find this product in Shopify.' };
    var orderQty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var bundleId = createBundleId();
    var variantUnit = getVariantUnitPriceCents();
    var props = collectLineItemProperties();
    props['_Line role'] = 'campaign';
    props['_Bundle id'] = bundleId;
    props['_Variant unit cents'] = String(variantUnit);

    var items = [{
      id: variantId,
      quantity: orderQty,
      properties: props
    }];

    var adjustment = calcCheckoutAdjustmentCents(orderQty);
    var adjustmentVariant = getCheckoutAdjustmentVariant();
    var adjustmentSetupError = getCheckoutAdjustmentSetupError(adjustment);
    if (adjustmentSetupError) {
      return { error: adjustmentSetupError };
    }

    if (adjustment > 0 && adjustmentVariant) {
      if (String(adjustmentVariant.id) === String(variantId)) {
        return { error: 'Checkout add-on product is misconfigured. Import ms-song-addon ($1.00) from shopify-products-import.csv.' };
      }
      var adjustmentQty = adjustmentCentsToQuantity(adjustment, adjustmentVariant.price);
      items.push({
        id: adjustmentVariant.id,
        quantity: adjustmentQty,
        properties: {
          '_Line role': 'checkout-adjustment',
          '_Bundle id': bundleId,
          '_Hidden': 'true',
          '_Variant unit cents': String(variantUnit),
          '_Unit total cents': props['_Unit total cents'] || '',
          '_Adjustment unit cents': String(adjustmentVariant.price),
          '_Adjustment cents': String(adjustment),
          'Note': 'Additional song add-ons'
        }
      });
    }

    return { items: items };
  }

  function fieldIsVisible(field) {
    var wrap = field.closest('.campaign-field');
    return !(wrap && wrap.hasAttribute('hidden'));
  }

  function getFieldLabel(field) {
    var wrap = field.closest('.campaign-field');
    var labelEl = wrap && wrap.querySelector('.campaign-field__label');
    return labelEl
      ? String(labelEl.textContent || '').replace(/\*+\?*/g, '').trim()
      : 'This field';
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function normalizeOptionalUrl(value) {
    value = String(value || '').trim();
    if (!value) return '';
    if (/^https?:\/\//i.test(value)) return value;
    if (/^(?:www\.)?[a-z0-9.-]+\.[a-z]{2,}/i.test(value)) {
      return 'https://' + value.replace(/^\/\//, '');
    }
    return value;
  }

  function validateOrderForm() {
    var invalidField = null;
    var invalidMessage = '';

    if (dynamicFields) {
      dynamicFields.querySelectorAll('input, select, textarea').forEach(function (field) {
        if (invalidField || !fieldIsVisible(field)) return;

        var val = String(field.value || '').trim();
        var label = getFieldLabel(field);

        if (field.required && !val) {
          invalidField = field;
          invalidMessage = 'Please fill in ' + label + '.';
          return;
        }

        if (field.type === 'email' && val && !isValidEmail(val)) {
          invalidField = field;
          invalidMessage = 'Please enter a valid email address.';
          return;
        }

        if (field.id === 'field-social' && val) {
          field.value = normalizeOptionalUrl(val);
        }
      });
    }

    if (qtyInput) {
      var qty = parseInt(qtyInput.value, 10);
      if (!qty || qty < 1 || qty > 99) {
        invalidField = qtyInput;
        invalidMessage = 'Please enter a valid quantity (1–99).';
      }
    }

    if (invalidField) {
      invalidField.focus();
      showToast(invalidMessage);
      if (orderSubmitHelp) {
        orderSubmitHelp.textContent = invalidMessage;
        orderSubmitHelp.hidden = false;
      }
      return false;
    }

    if (orderSubmitHelp) orderSubmitHelp.hidden = true;
    return true;
  }

  function collectLineItemProperties() {
    var props = { '_Campaign summary': buildCampaignSummary() };
    var total = calcOrderTotal();
    var discount = calcCouponDiscountAmount();
    var coupon = getEffectiveCoupon();
    var addonCount = getAddonSongCount();
    var addonPrice = calcAddonPricePerSong();
    if (addonCount > 0) {
      props['Additional Song Add-ons'] =
        addonCount + ' × ' + money(addonPrice) + ' = ' + money(calcAddonChargesTotal());
    }
    if (coupon) props['Coupon'] = coupon.code;
    if (discount > 0) props['Discount'] = money(discount);
    if (total > 0) {
      var orderQty = getOrderQty();
      props['Total'] = money(total);
      props['_Total cents'] = String(total);
      props['_Wizard qty'] = String(orderQty);
      props['_Unit total cents'] = String(Math.round(total / orderQty));
    }
    var compareTotal = calcCompareTotal();
    if (compareTotal > total && total > 0) {
      var compareOrderQty = getOrderQty();
      props['_Compare total'] = money(compareTotal);
      props['_Compare cents'] = String(compareTotal);
      props['_Unit compare cents'] = String(Math.round(compareTotal / compareOrderQty));
    }
    return props;
  }

  function collectCartAttributes() {
    return {
      _edit_category: state.category || '',
      _edit_package: state.package ? state.package.id : '',
      _edit_songs: state.songs.map(function (s) { return s.url; }).join('|')
    };
  }

  function parseSpotifyUrl(input) {
    var match = input.match(/spotify\.com\/(track|album)\/([a-zA-Z0-9]+)/);
    if (!match) return null;
    return { type: match[1], id: match[2], url: input.trim() };
  }

  function mockFromSearch(query) {
    var i = Math.abs(query.split('').reduce(function (a, c) { return a + c.charCodeAt(0); }, 0)) % MOCK_TRACKS.length;
    var t = MOCK_TRACKS[i];
    return {
      title: query.length > 3 ? query : t.title,
      artist: t.artist,
      art: t.art,
      url: 'https://open.spotify.com/track/preview-' + Date.now()
    };
  }

  function showToast(message) {
    if (!orderToast) return;
    orderToast.innerHTML = '<i class="ti ti-check"></i> ' + escapeHtml(message);
    orderToast.hidden = false;
    orderToast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      orderToast.classList.remove('is-visible');
      setTimeout(function () { orderToast.hidden = true; }, 250);
    }, 2600);
  }

  function updateSongBoardState() {
    var hasSongs = state.songs.length > 0;
    if (songEmpty) songEmpty.hidden = hasSongs;
    if (songTracksWrap) songTracksWrap.hidden = !hasSongs;
    if (songCount) songCount.textContent = String(state.songs.length);
    if (songTracksWrap) {
      songTracksWrap.classList.toggle('song-board__tracks--addons', getAddonSongCount() > 0);
    }
    if (songTracksIncludedBadge) {
      var includedCount = 0;
      for (var i = 0; i < state.songs.length; i++) {
        if (isIncludedSongIndex(i)) includedCount += 1;
      }
      songTracksIncludedBadge.hidden = includedCount === 0;
      songTracksIncludedBadge.textContent = includedCount > 1
        ? includedCount + ' included in package'
        : 'Included in package';
    }
    renderSongLimitWarning();
  }

  function renderSongLimitWarning() {
    if (!songLimitWarning) return;

    var addonCount = getAddonSongCount();
    var limit = getSongsPerOrderLimit();
    var show = addonCount > 0 && hasPackageSongLimit() && !!state.package;

    if (!show) {
      songLimitWarning.hidden = true;
      songLimitWarning.classList.remove('song-limit-warning--accepted');
      return;
    }

    songLimitWarning.hidden = false;
    songLimitWarning.classList.add('song-limit-warning--accepted');

    if (songLimitAllowed) songLimitAllowed.textContent = String(limit);
    if (songLimitSelected) songLimitSelected.textContent = String(state.songs.length);
    if (songLimitAdditional) songLimitAdditional.textContent = String(addonCount);

    var addonPrice = calcAddonPricePerSong();
    var addonTotal = calcAddonChargesTotal();
    var pkgName = state.package ? state.package.name : 'package';

    if (songLimitNote) {
      songLimitNote.textContent =
        addonCount + ' song' + (addonCount === 1 ? '' : 's') +
        ' exceed your ' + pkgName + ' limit. Add-ons are ' + money(calcAddonListPricePerSong()) +
        ' → ' + money(addonPrice) + ' each (20% off, ' + money(addonTotal) + ' total). ' +
        'Remove extra songs or keep them and pay the add-on charge at checkout.';
    }
  }

  function renderSongs() {
    if (!songRow) return;

    var html = '';
    state.songs.forEach(function (song, i) {
      var isAddon = isAddonSongIndex(i);
      var isIncluded = isIncludedSongIndex(i);
      html +=
        '<article class="song-card' +
          (i === summaryTrackIndex ? ' is-summary-active' : '') +
          (isAddon ? ' song-card--excess' : '') +
          '" data-index="' + i + '" data-summary-select="' + i + '" role="button" tabindex="0" aria-label="Preview ' + escapeHtml(song.title) + ' in summary">' +
          '<button type="button" class="song-card__remove" data-remove-song="' + i + '" aria-label="Remove song">&times;</button>' +
          buildSongCardArtHtml(song, isIncluded, isAddon) +
          '<p class="song-card__title">' + escapeHtml(song.title) + '</p>' +
          '<p class="song-card__artist">' + escapeHtml(song.artist) + '</p>' +
        '</article>';
    });

    songRow.innerHTML = html;
    updateSongBoardState();

    songRow.querySelectorAll('[data-remove-song]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var removed = parseInt(btn.dataset.removeSong, 10);
        state.songs.splice(removed, 1);
        if (summaryTrackIndex >= state.songs.length) {
          summaryTrackIndex = Math.max(0, state.songs.length - 1);
        } else if (removed < summaryTrackIndex) {
          summaryTrackIndex -= 1;
        }
        renderSongs();
        updatePromoteBtn();
        updateSummary();
      });
    });

    songRow.querySelectorAll('[data-summary-select]').forEach(function (card) {
      card.addEventListener('click', function () {
        setSummaryTrack(parseInt(card.dataset.summarySelect, 10), true);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSummaryTrack(parseInt(card.dataset.summarySelect, 10), true);
        }
      });
    });

    updatePromoteBtn();
  }

  function addSong(song, options) {
    options = options || {};
    if (state.songs.length >= MAX_SONGS) {
      if (!options.silent) {
        showSearchError('Maximum ' + MAX_SONGS + ' tracks per checkout.');
      }
      return false;
    }
    if (state.songs.some(function (s) {
      return s.url === song.url || (song.id && s.id === song.id);
    })) {
      if (!options.silent) showSearchError('This song is already added.');
      return false;
    }
    state.songs.push(normalizeSong(song));
    if (!options.silent) {
      summaryTrackIndex = state.songs.length - 1;
      renderSongs();
      if (songSearch) songSearch.value = '';
      hideSearchResults();
      showSearchError('');
      updateSummary();
      if (isExcessSongIndex(state.songs.length - 1)) {
        showToast('Added “' + song.title + '” — review the package limit warning below.');
      } else {
        showToast('Added “' + song.title + '”');
      }
      if (songSearch) songSearch.focus();
    }
    return true;
  }

  function addAlbumTracks(album, tracks) {
    if (!tracks || !tracks.length) {
      showSearchError('No tracks found in this album.');
      return;
    }

    var added = 0;
    var skipped = 0;
    var splitAdded = 0;
    tracks.forEach(function (track) {
      if (state.songs.length >= MAX_SONGS) {
        skipped += 1;
        return;
      }
      var willBeExcess = isExcessSongIndex(state.songs.length);
      if (addSong(track, { silent: true })) {
        added += 1;
        if (willBeExcess) splitAdded += 1;
      } else {
        skipped += 1;
      }
    });

    if (songSearch) songSearch.value = '';
    hideSearchResults();
    showSearchError('');

    if (added > 0) {
      summaryTrackIndex = state.songs.length - 1;
      renderSongs();
      updateSummary();
      var albumName = album && album.name ? album.name : 'album';
      var message = 'Added ' + added + ' track' + (added === 1 ? '' : 's') + ' from “' + albumName + '”';
      if (skipped > 0) {
        message += ' · ' + skipped + ' skipped (limit or duplicates)';
      }
      if (splitAdded > 0) {
        message += ' · ' + splitAdded + ' in add-on order' + (splitAdded === 1 ? '' : 's');
      }
      showToast(message);
      if (songSearch) songSearch.focus();
      return;
    }

    showSearchError('Could not add tracks from this album. You may have hit the ' + MAX_SONGS + '-track limit.');
  }

  function showSearchError(msg) {
    if (songSearchError) {
      songSearchError.textContent = msg;
      songSearchError.hidden = !msg;
    }
  }

  function hideSearchResults() {
    if (songSearchResults) songSearchResults.hidden = true;
  }

  function showSearchResults(items) {
    if (!songSearchResults) return;
    songSearchResults.innerHTML = items.map(function (item, i) {
      return (
        '<button type="button" class="song-search__result" data-pick="' + i + '">' +
          (item.art
            ? '<img class="song-search__art" src="' + escapeHtml(item.art) + '" alt="">'
            : '<span class="song-search__art song-search__art--placeholder"><i class="ti ti-music"></i></span>') +
          '<span class="song-search__meta">' +
            '<strong class="song-search__title">' + escapeHtml(item.title) + '</strong>' +
            '<span class="song-search__artist">' + escapeHtml(item.artist) + '</span>' +
          '</span>' +
          '<i class="ti ti-plus song-search__add" aria-hidden="true"></i>' +
        '</button>'
      );
    }).join('');
    songSearchResults.hidden = false;

    songSearchResults.querySelectorAll('[data-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addSong(items[parseInt(btn.dataset.pick, 10)]);
      });
    });
  }

  function fallbackSearchResults(q) {
    showSearchResults([
      mockFromSearch(q),
      mockFromSearch(q + ' remix')
    ]);
  }

  function fallbackTrackFromUrl(q, parsed) {
    if (parsed && parsed.type === 'album') {
      showSearchError('Album links need the Spotify API — paste track links or search by song name.');
      return;
    }
    addSong({
      id: parsed.id,
      title: 'Spotify Track',
      artist: 'Unknown artist',
      art: '',
      url: parsed.url || q
    });
  }

  function runSpotifyLookup(q) {
    var parsed = parseSpotifyUrl(q);
    var requestId = ++searchRequestId;

    if (!spotifyApi) {
      if (parsed) fallbackTrackFromUrl(q, parsed);
      else fallbackSearchResults(q);
      return;
    }

    if (songSearchResults) {
      songSearchResults.innerHTML = '<p class="song-board__loading">' +
        (parsed && parsed.type === 'album' ? 'Loading album tracks…' : 'Searching Spotify…') +
        '</p>';
      songSearchResults.hidden = false;
    }

    spotifyApi.resolve(q).then(function (result) {
      if (requestId !== searchRequestId) return;

      if (result.album && result.tracks && result.tracks.length) {
        addAlbumTracks(result.album, result.tracks);
        return;
      }

      if (result.track) {
        addSong(result.track);
        return;
      }

      if (result.tracks && result.tracks.length) {
        showSearchResults(result.tracks);
        return;
      }

      showSearchError('No tracks found.');
      hideSearchResults();
    }).catch(function (err) {
      if (requestId !== searchRequestId) return;
      hideSearchResults();
      if (parsed && parsed.type === 'album') {
        showSearchError(err.message || 'Could not load album tracks. Check the Spotify API server.');
        return;
      }
      showSearchError(err.message || 'Could not reach Spotify.');
      if (parsed) fallbackTrackFromUrl(q, parsed);
      else fallbackSearchResults(q);
    });
  }

  function handleSearchInput() {
    var q = songSearch ? songSearch.value.trim() : '';
    if (q.length < 2) {
      hideSearchResults();
      showSearchError('');
      return;
    }
    runSpotifyLookup(q);
  }

  function handleSearchTyping() {
    var q = songSearch ? songSearch.value.trim() : '';
    clearTimeout(searchDebounce);

    if (parseSpotifyUrl(q)) {
      hideSearchResults();
      showSearchError('');
      searchDebounce = setTimeout(function () {
        runSpotifyLookup(q);
      }, 150);
      return;
    }

    if (q.length < 2) {
      hideSearchResults();
      showSearchError('');
      searchRequestId += 1;
      return;
    }

    searchDebounce = setTimeout(function () {
      runSpotifyLookup(q);
    }, 350);
  }

  function updatePromoteBtn() {
    var count = state.songs.length;
    var ready = count > 0;
    if (btnPromoteSongs) btnPromoteSongs.disabled = !ready;
    if (step1Help) step1Help.hidden = ready;
    if (btnPromoteLabel) {
      btnPromoteLabel.textContent = count === 0
        ? 'Continue'
        : count === 1
          ? 'Continue with 1 track'
          : 'Continue with ' + count + ' tracks';
    }
  }

  function updateProgressBar() {
    if (orderProgressFill) {
      orderProgressFill.style.width = (state.step / 4 * 100) + '%';
    }
  }

  function isMobileLayout() {
    return window.matchMedia('(max-width: 960px)').matches;
  }

  function updateSummaryPanelState() {
    if (!orderSummaryPanel) return;
    if (isMobileLayout()) {
      orderSummaryPanel.open = state.step === 4;
    } else {
      orderSummaryPanel.open = true;
    }
  }

  function goToStep(n) {
    if (n === 4) {
      if (!canProceedToStep4()) {
        promptForSongsBeforeCheckout();
        return;
      }
    }

    if (n >= 3 && !state.category) {
      state.category = 'playlist';
      state.package = getLowestPackageForCategory(state.category);
      applyCanonicalPackagePrice(state.package);
      syncPackageCatalogPrice();
    }

    state.step = n;
    panels.forEach(function (p) {
      p.classList.toggle('active', parseInt(p.dataset.step, 10) === n);
    });
    steps.forEach(function (s) {
      var sn = parseInt(s.dataset.step, 10);
      s.classList.toggle('active', sn === n);
      s.classList.toggle('done', sn < n);
      if (sn === n) {
        s.setAttribute('aria-current', 'step');
      } else {
        s.removeAttribute('aria-current');
      }
    });
    updateProgressBar();
    updateSummaryPanelState();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (n === 2) renderCategories();
    if (n === 3) renderPackages();
    if (n === 4) renderFields();
    updateSummary();
  }

  function renderCategories() {
    if (!categoryGrid) return;
    categoryGrid.innerHTML = Object.keys(CATEGORIES).map(function (key) {
      var c = CATEGORIES[key];
      var perks = (c.perks || []).map(function (p) {
        return '<span class="category-card__perk">' + escapeHtml(p) + '</span>';
      }).join('');
      return (
        '<button type="button" class="category-card' +
          (c.featured ? ' category-card--featured' : '') +
          (state.category === key ? ' selected' : '') +
          '" data-category="' + key + '">' +
          (c.featured ? '<span class="category-card__badge">Most chosen</span>' : '') +
          '<div class="category-card__icon"><i class="ti ' + c.icon + '"></i></div>' +
          '<div class="category-card__body">' +
            '<span class="category-card__tagline">' + escapeHtml(c.tagline || '') + '</span>' +
            '<h3>' + escapeHtml(c.label) + '</h3>' +
            '<p>' + escapeHtml(c.desc || '') + '</p>' +
            '<div class="category-card__perks">' + perks + '</div>' +
          '</div>' +
          '<div class="category-card__action">' +
            '<span class="category-card__from">From ' + escapeHtml(c.from) + '</span>' +
            '<span class="category-card__cta">Select <i class="ti ti-arrow-right"></i></span>' +
          '</div>' +
        '</button>'
      );
    }).join('');

    categoryGrid.querySelectorAll('[data-category]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.category = btn.dataset.category;
        state.package = getLowestPackageForCategory(state.category);
        applyCanonicalPackagePrice(state.package);
        refreshOrderAfterSelectionChange({ rerenderCategories: true });
        setTimeout(function () { goToStep(3); }, 200);
      });
    });
  }

  function renderPackages() {
    if (!packageGrid || !state.category) return;
    var list = getPackagesForCategory(state.category);
    packageGrid.innerHTML = list.map(function (pkg) {
      var displayPrice = getCanonicalPackagePrice(state.category, pkg.id);
      if (displayPrice == null) displayPrice = pkg.price;
      var showDiscount = hasStandardPackageDiscount(displayPrice);
      var priceHtml =
        (showDiscount ? buildPackageDiscountBadgeHtml() : '') +
        buildPackagePriceHtml(displayPrice, { perLink: state.category === 'social' });
      return (
        '<button type="button" class="package-option' +
          (pkg.featured ? ' package-option--featured' : '') +
          (state.package && state.package.id === pkg.id ? ' selected' : '') +
          '" data-package="' + pkg.id + '">' +
          (pkg.featured ? '<span class="package-option__badge">Recommended</span>' : '') +
          '<div class="package-option__streams"><i class="ti ti-chart-line"></i> ' + escapeHtml(pkg.streams) + ' streams</div>' +
          '<h4>' + escapeHtml(pkg.name) + '</h4>' +
          (pkg.maxSongs ? '<p class="package-option__songs">' + formatSongLimitLabel(pkg.maxSongs, state.category) + '</p>' : '') +
          (state.category === 'social' ? '<p class="package-option__songs">Per link · total × number of tracks</p>' : '') +
          '<div class="package-option__price">' + priceHtml + '</div>' +
          '<p class="package-option__desc">' + escapeHtml(pkg.desc) + '</p>' +
          '<span class="package-option__cta">Choose package <i class="ti ti-arrow-right"></i></span>' +
        '</button>'
      );
    }).join('');

    packageGrid.querySelectorAll('[data-package]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = getPackagesForCategory(state.category);
        state.package = list.find(function (p) { return p.id === btn.dataset.package; }) || null;
        applyCanonicalPackagePrice(state.package);
        refreshOrderAfterSelectionChange();
        setTimeout(function () {
          if (!canProceedToStep4()) {
            promptForSongsBeforeCheckout();
            return;
          }
          goToStep(4);
        }, 200);
      });
    });
  }

  function getFieldType() {
    if (!state.package) return 'playlist';
    if (state.category === 'playlist') return 'playlist';
    if (state.category === 'algorithmic') return 'algorithmic';
    return state.package.fieldType || 'playlist';
  }

  function renderFields() {
    if (!dynamicFields) return;
    var type = getFieldType();
    var html = '';

    if (type === 'playlist') {
      var durationOptions = [];
      var handle = getPackageHandle();
      var product = handle && orderCatalog && orderCatalog.products[handle];
      if (product && product.variants.length > 1) {
        product.variants.forEach(function (v) {
          var listPrice = variantListPriceCents(v);
          durationOptions.push([v.title + ' (' + money(listPrice) + ')', String(listPrice)]);
        });
      } else {
        durationOptions = [
          ['1 Month ($45.00)', '4500'],
          ['2Month ($85.00)', '8500']
        ];
      }

      html +=
        fieldSelect('Booking Type*?', 'bookingType', 'Select booking type…', [
          ['Standard', 'Standard'],
          ['Pre-Order', 'Pre-Order']
        ], 'Standard: For music already on Spotify. Pre-Book: For scheduled releases.') +
        fieldDate('Date of Music\'s Release*', 'releaseDate', 'preorder-field', true) +
        fieldSelect('Duration*?', 'duration', 'Choose duration…', durationOptions, 'How long your playlist promotion runs.', true);
    }

    if (type === 'editorial') {
      html += fieldSelect('Spotify Editorial Streams*?', 'editorialStreams', 'Select reach…', [
        ['5k-10k Plays ($79.00)', '7900'],
        ['15k-20k Plays ($159.00)', '15900'],
        ['25k-30k Plays ($249.00)', '24900'],
        ['35k-40k Plays ($349.00)', '34900'],
        ['45k-50k Plays ($499.00)', '49900']
      ], 'Choose your editorial stream package.', true);
    }

    if (type === 'algorithmic' || type === 'radio' || type === 'editorial') {
      html += fieldSelect('Target Location?', 'targetLocation', 'Select location…', [
        ['WorldWide', 'WorldWide'], ['Europe', 'Europe'], ['Canada', 'Canada'], ['USA', 'USA'], ['Asia', 'Asia']
      ], 'Majority of plays from selected region.');
    }

    if (type === 'meta') {
      html +=
        fieldSelect('Campaign Budget?', 'metaBudget', 'Select budget…', [
          ['$10 per Day', '10'], ['$20 per Day', '20'], ['$30 per Day', '30']
        ], 'Daily ad budget.') +
        fieldSelect('Duration?', 'metaDuration', 'Select duration…', [
          ['7 days', '7'], ['15 Days', '15'], ['1 Month', '30'], ['2 Months', '60'], ['3 Months', '90']
        ], 'How long ads run.');
    }

    html +=
      fieldInput('text', 'Genre*?', 'genre', 'e.g. Pop, Hip-Hop, EDM', '', true) +
      fieldInput('email', 'Contact Email*?', 'email', 'you@example.com', '', true) +
      fieldInput('text', 'Artist Social Profile?', 'social', 'https://instagram.com/… or @handle') +
      fieldTextarea('Add Notes', 'notes', 'Any extra details…');

    dynamicFields.innerHTML = html;

    var editorialStreamsField = document.getElementById('field-editorialStreams');
    if (editorialStreamsField && state.package && state.package.fieldType === 'editorial') {
      var pkgPrice = String(getCanonicalPackagePrice(state.category, state.package.id) || state.package.price);
      Array.prototype.forEach.call(editorialStreamsField.options, function (opt) {
        if (opt.dataset.price === pkgPrice) editorialStreamsField.value = opt.value;
      });
    }

    var booking = document.getElementById('field-bookingType');
    var preorderField = document.querySelector('.preorder-field');
    if (booking && preorderField) {
      function togglePreorder() {
        var show = booking.value === 'Pre-Order';
        preorderField.hidden = !show;
        var input = preorderField.querySelector('[data-input]');
        var wrap = preorderField.querySelector('.date-picker-wrap');
        if (input) input.required = show;
        if (!show && window.MSDatePicker) {
          window.MSDatePicker.clearWrap(wrap);
        }
      }
      booking.addEventListener('change', togglePreorder);
      togglePreorder();
    }

    if (window.MSDatePicker) window.MSDatePicker.init(dynamicFields);

    dynamicFields.querySelectorAll('[data-price-option]').forEach(function (sel) {
      sel.addEventListener('change', updateSummary);
    });

    dynamicFields.addEventListener('change', updateSummary);
    dynamicFields.addEventListener('input', updateSummary);
  }

  function fieldSelect(label, id, placeholder, options, hint, priceField) {
    var propName = adminPropName(label);
    var opts = '<option value="">' + placeholder + '</option>';
    options.forEach(function (o) {
      opts += '<option value="' + escapeHtml(o[0]) + '"' +
        (priceField ? ' data-price="' + o[1] + '"' : '') + '>' + escapeHtml(o[0]) + '</option>';
    });
    return (
      '<div class="campaign-field">' +
        '<label class="campaign-field__label" for="field-' + id + '">' + label + '</label>' +
        (hint ? '<p class="campaign-field__hint">' + hint + '</p>' : '') +
        '<select class="campaign-field__input" id="field-' + id + '" name="' + escapeHtml(propName) + '"' +
          (priceField ? ' data-price-option' : '') + '>' + opts + '</select>' +
      '</div>'
    );
  }

  function fieldDate(label, id, extraClass, required) {
    var propName = adminPropName(label);
    return (
      '<div class="campaign-field date-picker-field' + (extraClass ? ' ' + extraClass : '') + '"' +
        (extraClass === 'preorder-field' ? ' hidden' : '') + '>' +
        '<label class="campaign-field__label" for="field-' + id + '">' + label + '</label>' +
        '<div class="date-picker-wrap flatpickr">' +
          '<input class="campaign-field__input date-picker__input" type="text" id="field-' + id + '" name="' + escapeHtml(propName) + '"' +
            ' placeholder="Select release date" autocomplete="off" data-input' +
            (required ? ' required' : '') + '>' +
          '<button type="button" class="date-picker__btn" data-toggle aria-label="Open calendar">' +
            '<i class="ti ti-calendar" aria-hidden="true"></i>' +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function fieldInput(type, label, id, placeholder, extraClass, required) {
    var propName = adminPropName(label);
    var extraAttrs = ' autocomplete="off"';
    if (id === 'social') extraAttrs += ' maxlength="200"';
    if (id === 'notes') extraAttrs += ' maxlength="500"';
    if (id === 'email') extraAttrs += ' autocomplete="email"';
    return (
      '<div class="campaign-field' + (extraClass ? ' ' + extraClass : '') + '"' +
        (extraClass === 'preorder-field' ? ' hidden' : '') + '>' +
        '<label class="campaign-field__label" for="field-' + id + '">' + label + '</label>' +
        '<input class="campaign-field__input" type="' + type + '" id="field-' + id + '" name="' + escapeHtml(propName) + '"' +
          (placeholder ? ' placeholder="' + placeholder + '"' : '') +
          (required ? ' required' : '') + extraAttrs + '>' +
      '</div>'
    );
  }

  function fieldTextarea(label, id, placeholder) {
    var propName = adminPropName(label);
    return (
      '<div class="campaign-field">' +
        '<label class="campaign-field__label" for="field-' + id + '">' + label + '</label>' +
        '<textarea class="campaign-field__input campaign-field__textarea" id="field-' + id + '" name="' + escapeHtml(propName) + '" rows="3" placeholder="' + placeholder + '" autocomplete="off" maxlength="500"></textarea>' +
      '</div>'
    );
  }

  function calcUnitPrice() {
    if (!state.package) return 0;
    syncPackageCatalogPrice();
    var price = getCanonicalPackagePrice(state.category, state.package.id);
    if (price == null) price = state.package.price;
    var fieldType = getFieldType();

    if (fieldType === 'playlist') {
      var duration = document.getElementById('field-duration');
      if (duration && duration.selectedOptions[0] && duration.selectedOptions[0].dataset.price) {
        price = parseInt(duration.selectedOptions[0].dataset.price, 10) || price;
      }
    }

    if (fieldType === 'editorial') {
      var editorialStreams = document.getElementById('field-editorialStreams');
      if (editorialStreams && editorialStreams.selectedOptions[0] && editorialStreams.selectedOptions[0].dataset.price) {
        price = parseInt(editorialStreams.selectedOptions[0].dataset.price, 10) || price;
      }
    }

    if (fieldType === 'meta' && state.category !== 'social') {
      var metaBudget = document.getElementById('field-metaBudget');
      var metaDuration = document.getElementById('field-metaDuration');
      if (metaBudget && metaDuration && metaBudget.value && metaDuration.value) {
        var daily = parseInt(metaBudget.selectedOptions[0].dataset.price, 10) || 0;
        var days = parseInt(metaDuration.selectedOptions[0].dataset.price, 10) || 0;
        price = daily * days * 100;
      }
    }

    return price;
  }

  function getOrderQty() {
    return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : (state.quantity || 1);
  }

  function getBatchIndexForSong(globalIndex) {
    return globalIndex;
  }

  function getBatchNumberForSong(globalIndex) {
    return 0;
  }

  function isIncludedSongIndex(globalIndex) {
    if (!hasPackageSongLimit()) return true;
    var limit = getSongsPerOrderLimit();
    return globalIndex < limit;
  }

  function isAddOnSongIndex(globalIndex) {
    if (!hasPackageSongLimit()) return false;
    return globalIndex >= getSongsPerOrderLimit();
  }

  function getCouponDefinition(code) {
    var normalized = String(code || '').trim().toUpperCase();
    if (!normalized) return null;

    if (orderCatalog && orderCatalog.coupons && orderCatalog.coupons[normalized]) {
      var catalogCoupon = orderCatalog.coupons[normalized];
      return {
        code: normalized,
        label: catalogCoupon.label || normalized,
        type: catalogCoupon.type || 'percent',
        percent: catalogCoupon.percent,
        amountOff: catalogCoupon.amountOff,
        shopify: catalogCoupon.shopify !== false
      };
    }

    return {
      code: normalized,
      label: 'Discount applied at checkout',
      type: 'shopify',
      shopify: true
    };
  }

  function isCatalogCoupon(code) {
    var normalized = normalizeCouponCode(code);
    return !!(orderCatalog && orderCatalog.coupons && orderCatalog.coupons[normalized]);
  }

  function getEffectiveCoupon() {
    if (state.appliedCouponCode) {
      return getCouponDefinition(state.appliedCouponCode);
    }
    return null;
  }

  function syncCouponState() {
    if (state.appliedCouponCode) {
      var def = getCouponDefinition(state.appliedCouponCode);
      if (!def || def.type === 'multi-track') {
        state.appliedCouponCode = null;
      }
    }
  }

  function calcOrderTotal() {
    if (!state.package) return 0;
    var subtotal = calcOrderSubtotalBeforeCoupon();
    var coupon = getEffectiveCoupon();

    if (state.cartPricing && state.appliedCouponCode) {
      if (state.cartPricing.shopifyDiscountCents > 0 || state.cartPricing.totalCents < subtotal) {
        return state.cartPricing.totalCents;
      }
    }

    if (coupon && coupon.percent) {
      return Math.round(subtotal * (1 - coupon.percent / 100));
    }
    if (coupon && coupon.amountOff) {
      return Math.max(0, subtotal - coupon.amountOff * getOrderQty());
    }
    return subtotal;
  }

  function calcCouponDiscountAmount() {
    var subtotal = calcOrderSubtotalBeforeCoupon();
    var total = calcOrderTotal();
    return Math.max(0, subtotal - total);
  }

  function calcCompareTotal() {
    if (!state.package) return 0;
    return (calcPackageListPrice() + calcAddonListChargesTotal()) * getOrderQty();
  }

  function hasVisibleOrderTotal() {
    return calcOrderTotal() > 0;
  }

  function getSummaryUnitListPrice() {
    if (!state.package) return 0;
    return getCanonicalPackagePrice(state.category, state.package.id) || calcUnitPrice();
  }

  function getSummaryUnitBasePrice() {
    var list = getSummaryUnitListPrice();
    return list > 0 ? calcDiscountedListPrice(list) : 0;
  }

  function getSummaryPackagePriceLabel() {
    if (isPerLinkPricing() && state.songs.length === 0) return 'Base price (per link)';
    return 'Package price';
  }

  function buildSummaryPackagePriceRow(unit, packageList, packageBase) {
    if (!state.package) return '';

    var listPrice = packageList > 0 ? packageList : getSummaryUnitListPrice();
    var basePrice = packageBase > 0 ? packageBase : getSummaryUnitBasePrice();
    if (listPrice <= 0 && basePrice <= 0) return '';

    var prefix = '';
    if (isPerLinkPricing()) {
      if (state.songs.length > 0) {
        prefix = state.songs.length + ' × ' + money(unit) + ' = ';
      } else {
        prefix = 'Per link · ';
      }
    }

    return (
      '<div class="order-summary__row"><span>' + getSummaryPackagePriceLabel() + '</span><strong>' +
        prefix +
        (listPrice > basePrice
          ? '<span class="order-summary__total-compare">' + money(listPrice) + '</span> '
          : '') +
        money(basePrice) +
        (PACKAGE_DISCOUNT > 0 ? ' <span class="order-summary__total-save">20% off</span>' : '') +
      '</strong></div>'
    );
  }

  function buildSummaryBaseTotalHtml() {
    var unitList = getSummaryUnitListPrice();
    var unitBase = getSummaryUnitBasePrice();
    if (unitBase <= 0) return buildSummaryPendingHtml();

    var totalLabel = isPerLinkPricing()
      ? (state.songs.length === 0 ? 'From (per link)' : 'Total')
      : 'From';
    var pendingNote = isPerLinkPricing() && state.songs.length === 0
      ? '<p class="order-summary__pending">Add tracks to calculate your order total</p>'
      : '';

    return (
      pendingNote +
      '<div class="order-summary__total order-summary__total--estimate">' +
        '<span>' + totalLabel + '</span>' +
        '<div class="order-summary__total-value">' +
          (unitList > unitBase
            ? '<span class="order-summary__total-compare" id="orderTotalCompare">' + money(unitList) + '</span>'
            : '') +
          '<span class="order-summary__total-amount" id="orderTotal">' + money(unitBase) + '</span>' +
          (PACKAGE_DISCOUNT > 0 ? '<span class="order-summary__total-save">20% off</span>' : '') +
        '</div>' +
      '</div>'
    );
  }

  function buildSummaryPendingHtml() {
    return '<p class="order-summary__pending">Add tracks to see your total</p>';
  }

  function buildSummaryTotalHtml(unit, qty) {
    var total = calcOrderTotal();
    if (total <= 0) {
      if (state.package && getSummaryUnitBasePrice() > 0) {
        return buildSummaryBaseTotalHtml();
      }
      return buildSummaryPendingHtml();
    }
    var compareTotal = calcCompareTotal();
    var saveAmount = compareTotal > total ? compareTotal - total : 0;
    var coupon = getEffectiveCoupon();
    var discountAmount = calcCouponDiscountAmount();
    var showCouponRow = !!coupon;
    var showDiscountRow = discountAmount > 0 && coupon;

    var compareHtml = saveAmount
      ? '<span class="order-summary__total-compare" id="orderTotalCompare">' + money(compareTotal) + '</span>'
      : '';

    var saveHtml = saveAmount
      ? '<span class="order-summary__total-save">Save ' + money(saveAmount) + '</span>'
      : '';

    var couponHtml = showCouponRow
      ? '<div class="order-summary__row order-summary__row--coupon">' +
          '<span>Coupon</span>' +
          '<strong class="order-summary__coupon-code">' + escapeHtml(coupon.code) + '</strong>' +
        '</div>'
      : '';

    var discountHtml = showDiscountRow
      ? '<div class="order-summary__discount order-summary__row">' +
          '<span>Discount</span>' +
          '<strong>-' + money(discountAmount) + '</strong>' +
        '</div>'
      : '';

    return (
      couponHtml +
      discountHtml +
      '<div class="order-summary__total">' +
        '<span>Total</span>' +
        '<div class="order-summary__total-value">' +
          compareHtml +
          '<span class="order-summary__total-amount" id="orderTotal">' + money(total) + '</span>' +
          saveHtml +
        '</div>' +
      '</div>'
    );
  }

  function syncSummaryTrackIndex() {
    if (state.songs.length !== summaryStackSongCount) {
      if (summaryTrackIndex >= state.songs.length) {
        summaryTrackIndex = Math.max(0, state.songs.length - 1);
      }
    } else if (summaryTrackIndex >= state.songs.length) {
      summaryTrackIndex = Math.max(0, state.songs.length - 1);
    }
  }

  function buildSummaryStackShell() {
    var backLayers = '';
    var maxBack = Math.min(Math.max(state.songs.length - 1, 0), 4);
    var i;
    for (i = maxBack; i >= 1; i -= 1) {
      var rot = stackLayerRotation(i);
      var tiltClass = rot < 0 ? 'summary-stack__layer--tilt-left' : 'summary-stack__layer--tilt-right';
      backLayers +=
        '<div class="summary-stack__layer ' + tiltClass + ' glass-card" data-back-layer="' + i +
        '" style="--stack-rotate:' + rot + 'deg;--stack-depth:' + i + '" hidden aria-hidden="true">' +
          '<div class="summary-stack__layer-inner" data-back-layer-art></div>' +
        '</div>';
    }

    return (
      '<div class="summary-stack" data-summary-stack>' +
        '<div class="summary-stack__stage">' +
          '<div class="summary-stack__deck">' +
            '<div class="summary-stack__backs" aria-hidden="true">' + backLayers + '</div>' +
            '<article class="summary-stack__card summary-stack__layer--front glass-card">' +
              '<div class="summary-stack__content" data-summary-content>' +
                '<div class="summary-stack__art-wrap">' +
                  '<div class="summary-stack__art-slot" data-summary-art-slot></div>' +
                  '<span class="summary-stack__badge" data-summary-badge hidden>20% OFF</span>' +
                  '<span class="summary-stack__play-slot" data-summary-play-slot></span>' +
                '</div>' +
                '<div class="summary-stack__meta">' +
                  '<strong class="summary-stack__title" data-summary-title></strong>' +
                  '<span class="summary-stack__artist" data-summary-artist hidden></span>' +
                  '<span class="summary-stack__album" data-summary-album hidden></span>' +
                '</div>' +
                '<div class="summary-stack__dots" data-summary-dots role="tablist" aria-label="Selected tracks" hidden></div>' +
                '<button type="button" class="summary-stack__nav" data-summary-next aria-label="Next track" hidden>' +
                  '<span class="summary-stack__nav-text">' +
                    '<strong>Next track</strong>' +
                    '<em data-summary-nav-count></em>' +
                  '</span>' +
                  '<span class="summary-stack__nav-icon" aria-hidden="true">' + SUMMARY_PLAY_ICON + '</span>' +
                '</button>' +
              '</div>' +
            '</article>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderSummaryArtMarkup(song) {
    var data = normalizeSong(song);
    if (data.art) {
      return (
        '<img class="summary-stack__art" data-summary-art src="' + escapeHtml(data.art) + '" alt="' +
        escapeHtml(data.title ? data.title + ' artwork' : 'Track artwork') + '" loading="lazy">'
      );
    }
    return (
      '<img class="summary-stack__art summary-stack__art--fallback" data-summary-art src="' + DEFAULT_SONG_ART +
      '" alt="" role="presentation">'
    );
  }

  function renderSummaryPlayMarkup(song) {
    var data = normalizeSong(song);
    if (data.url) {
      return (
        '<a class="summary-stack__art-play" data-summary-play href="' + escapeHtml(data.url) +
        '" target="_blank" rel="noopener" aria-label="Open ' + escapeHtml(data.title || 'track') + ' on Spotify">' +
          SUMMARY_PLAY_ICON +
        '</a>'
      );
    }
    return (
      '<span class="summary-stack__art-play" data-summary-play aria-hidden="true">' +
        SUMMARY_PLAY_ICON +
      '</span>'
    );
  }

  function applySummaryBackLayers(stack) {
    var idx = Math.min(summaryTrackIndex, state.songs.length - 1);
    var layers = stack.querySelectorAll('[data-back-layer]');
    layers.forEach(function (layer) {
      var depth = parseInt(layer.dataset.backLayer, 10);
      var songOffset = depth;
      if (state.songs.length <= songOffset) {
        layer.hidden = true;
        layer.setAttribute('aria-hidden', 'true');
        return;
      }
      var songIdx = (idx + songOffset) % state.songs.length;
      var artWrap = layer.querySelector('[data-back-layer-art]');
      if (artWrap) {
        artWrap.innerHTML = renderSummaryArtMarkup(state.songs[songIdx]);
        bindSummaryArtFallback(artWrap.querySelector('[data-summary-art]'));
      }
      layer.hidden = false;
      layer.setAttribute('aria-hidden', 'true');
    });
  }

  function applySummaryStackData() {
    var stack = orderSummary && orderSummary.querySelector('[data-summary-stack]');
    if (!stack || !state.songs.length) return;

    var idx = Math.min(summaryTrackIndex, state.songs.length - 1);
    var song = normalizeSong(state.songs[idx]);
    var hasMultiple = state.songs.length > 1;

    applySummaryBackLayers(stack);

    var artSlot = stack.querySelector('[data-summary-art-slot]');
    if (artSlot) {
      artSlot.innerHTML = renderSummaryArtMarkup(state.songs[idx]);
      bindSummaryArtFallback(artSlot.querySelector('[data-summary-art]'));
    }

    var badge = stack.querySelector('[data-summary-badge]');
    if (badge) {
      badge.hidden = !(state.package && PACKAGE_DISCOUNT > 0);
      if (!badge.hidden) badge.textContent = getPackageDiscountPercent() + '% OFF';
    }

    var playSlot = stack.querySelector('[data-summary-play-slot]');
    if (playSlot) playSlot.innerHTML = renderSummaryPlayMarkup(state.songs[idx]);

    var titleEl = stack.querySelector('[data-summary-title]');
    if (titleEl) titleEl.textContent = song.title || 'Untitled track';

    var artistEl = stack.querySelector('[data-summary-artist]');
    if (artistEl) {
      if (song.artist) {
        artistEl.textContent = song.artist;
        artistEl.hidden = false;
      } else {
        artistEl.textContent = '';
        artistEl.hidden = true;
      }
    }

    var albumEl = stack.querySelector('[data-summary-album]');
    if (albumEl) {
      if (song.album) {
        albumEl.textContent = song.album;
        albumEl.hidden = false;
      } else {
        albumEl.textContent = '';
        albumEl.hidden = true;
      }
    }

    var dotsEl = stack.querySelector('[data-summary-dots]');
    if (dotsEl) {
      if (hasMultiple) {
        dotsEl.hidden = false;
        dotsEl.innerHTML = state.songs.map(function (_, i) {
          return (
            '<button type="button" class="summary-stack__dot' + (i === idx ? ' is-active' : '') +
            '" data-summary-dot="' + i + '" role="tab" aria-label="Track ' + (i + 1) +
            '" aria-selected="' + (i === idx ? 'true' : 'false') + '"></button>'
          );
        }).join('');
      } else {
        dotsEl.hidden = true;
        dotsEl.innerHTML = '';
      }
    }

    var navBtn = stack.querySelector('[data-summary-next]');
    var navCount = stack.querySelector('[data-summary-nav-count]');
    if (navBtn && navCount) {
      if (hasMultiple) {
        navBtn.removeAttribute('hidden');
        navCount.textContent = (idx + 1) + ' of ' + state.songs.length;
      } else {
        navBtn.setAttribute('hidden', '');
        navCount.textContent = '';
      }
    }
  }

  function syncSummaryStack(animate) {
    var songsWrap = orderSummary && orderSummary.querySelector('#orderSummarySongs');
    if (!songsWrap) return;

    if (!state.songs.length) {
      songsWrap.innerHTML = '<p class="order-summary__empty">No songs yet</p>';
      summaryStackSongCount = 0;
      return;
    }

    var needsMount = !songsWrap.querySelector('[data-summary-stack]') ||
      summaryStackSongCount !== state.songs.length;

    if (needsMount) {
      songsWrap.innerHTML = buildSummaryStackShell();
      summaryStackSongCount = state.songs.length;
      animate = false;
    }

    if (animate) {
      var content = songsWrap.querySelector('[data-summary-content]');
      if (content) {
        content.classList.remove('is-entering');
        content.classList.add('is-changing');
        window.setTimeout(function () {
          applySummaryStackData();
          content.classList.remove('is-changing');
          content.classList.add('is-entering');
          window.setTimeout(function () {
            content.classList.remove('is-entering');
          }, 320);
        }, 180);
        return;
      }
    }

    applySummaryStackData();
  }

  function ensureSummaryLayout() {
    if (!orderSummary) return;
    if (orderSummary.querySelector('#orderSummarySongs')) return;
    orderSummary.innerHTML =
      '<h3>Summary</h3>' +
      '<div class="order-summary__songs" id="orderSummarySongs"></div>' +
      '<div id="orderSummaryDetails"></div>';
  }

  function renderSummaryDetails() {
    var detailsEl = orderSummary && orderSummary.querySelector('#orderSummaryDetails');
    if (!detailsEl) return;

    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    state.quantity = qty;

    var unit = calcUnitPrice();
    var total = calcOrderTotal();
    var songLimit = getMaxSongs();
    var packageLimitActive = hasPackageSongLimit();
    var addonCount = getAddonSongCount();
    var addonPrice = calcAddonPricePerSong();
    var addonTotal = calcAddonChargesTotal();
    var packageBase = calcPackageBaseTotal();
    var packageList = calcPackageListPrice();

    var catLabel = state.category ? CATEGORIES[state.category].label : '—';
    var perLinkSuffix = isPerLinkPricing() ? ' per link' : '';
    var pkgLabel = state.package
      ? state.package.name + ' · ' + money(unit) + perLinkSuffix +
        (packageLimitActive && songLimit < MAX_SONGS ? ' · up to ' + songLimit + ' songs' : '')
      : '—';

    detailsEl.innerHTML =
      '<div class="order-summary__row"><span>Category</span><strong>' + catLabel + '</strong></div>' +
      '<div class="order-summary__row order-summary__row--package">' +
        '<span>Package</span>' +
        '<span class="order-summary__row-value">' +
          '<strong>' + pkgLabel + '</strong>' +
          (state.category ? '<button type="button" class="order-summary__change" data-change-plan>Change</button>' : '') +
        '</span>' +
      '</div>' +
      (packageLimitActive && songLimit < MAX_SONGS
        ? '<div class="order-summary__row"><span>Package allows</span><strong>' + songLimit + ' songs</strong></div>'
        : '') +
      (state.songs.length > 0
        ? '<div class="order-summary__row"><span>Selected</span><strong>' + state.songs.length + ' songs</strong></div>'
        : '') +
      (addonCount > 0
        ? '<div class="order-summary__row order-summary__row--warning"><span>Additional Song Add-ons</span><strong>' +
          addonCount + ' songs</strong></div>'
        : '') +
      buildSummaryPackagePriceRow(unit, packageList, packageBase) +
      (addonCount > 0
        ? '<div class="order-summary__row order-summary__row--addon"><span>Additional Song Add-ons (' +
          addonCount + ' × ' + money(calcAddonListPricePerSong()) + ' → ' + money(addonPrice) + ')</span><strong>' +
          money(addonTotal) + '</strong></div>'
        : '') +
      '<div class="order-summary__row"><span>Quantity</span><strong>×' + qty + '</strong></div>' +
      buildSummaryTotalHtml(unit, qty) +
      '<p class="order-summary__guarantee"><i class="ti ti-shield-check"></i> 100% organic · Live in 24 hrs · Secure checkout</p>';

    if (orderTotal) {
      orderTotal.textContent = hasVisibleOrderTotal()
        ? money(total)
        : (getSummaryUnitBasePrice() > 0 ? money(getSummaryUnitBasePrice()) : '');
    }
    if (orderSummaryToggleTotal) {
      if (!hasVisibleOrderTotal()) {
        var unitBase = getSummaryUnitBasePrice();
        var unitList = getSummaryUnitListPrice();
        if (unitBase > 0) {
          if (unitList > unitBase) {
            orderSummaryToggleTotal.innerHTML =
              '<span class="order-summary-panel__total-compare">' + money(unitList) + '</span>' +
              '<span class="order-summary-panel__total-amount">' + money(unitBase) +
                (isPerLinkPricing() ? ' / link' : '') +
              '</span>';
          } else {
            orderSummaryToggleTotal.textContent = money(unitBase) + (isPerLinkPricing() ? ' / link' : '');
          }
        } else {
          orderSummaryToggleTotal.textContent = '—';
        }
      } else {
        var compareTotal = calcCompareTotal();
        if (compareTotal > total && total > 0) {
          orderSummaryToggleTotal.innerHTML =
            '<span class="order-summary-panel__total-compare">' + money(compareTotal) + '</span>' +
            '<span class="order-summary-panel__total-amount">' + money(total) + '</span>';
        } else {
          orderSummaryToggleTotal.textContent = money(total);
        }
      }
    }
  }

  function setSummaryTrack(newIndex, animate) {
    if (!state.songs.length) return;
    syncSummaryTrackIndex();
    var idx = ((newIndex % state.songs.length) + state.songs.length) % state.songs.length;
    var changed = idx !== summaryTrackIndex;
    summaryTrackIndex = idx;
    syncSummaryStack(animate && changed);
    renderSongs();
  }

  function renderCouponUI() {
    var appliedEl = document.getElementById('orderCouponApplied');
    var formEl = document.getElementById('orderCouponForm');
    var textEl = document.getElementById('orderCouponChipText');
    var inputEl = document.getElementById('orderCouponInput');
    var errorEl = document.getElementById('orderCouponError');
    if (!appliedEl || !formEl) return;

    var coupon = getEffectiveCoupon();
    if (coupon) {
      appliedEl.hidden = false;
      if (textEl) {
        textEl.innerHTML =
          '<strong class="order-coupon__chip-code">' + escapeHtml(coupon.code) + '</strong>' +
          '<span class="order-coupon__chip-label">' + escapeHtml(coupon.label || '') + '</span>';
      }
      formEl.classList.add('order-coupon__form--has-applied');
      if (inputEl) inputEl.placeholder = 'Replace with another code';
    } else {
      appliedEl.hidden = true;
      if (textEl) textEl.innerHTML = '';
      formEl.classList.remove('order-coupon__form--has-applied');
      if (inputEl) inputEl.placeholder = 'Enter coupon code';
    }
    if (errorEl) errorEl.hidden = true;
  }

  function setCouponError(message) {
    var errorEl = document.getElementById('orderCouponError');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function finishApplyCoupon(code) {
    state.appliedCouponCode = code;
    state.couponUserRemoved = false;
    setCouponError('');
    if (document.getElementById('orderCouponInput')) {
      document.getElementById('orderCouponInput').value = '';
    }
    renderCouponUI();

    return syncWizardCartWithPricing().then(function (cart) {
      var def = getCouponDefinition(code);
      if (cart && def && def.shopify !== false && !isCatalogCoupon(code)) {
        var discountOk = (cart.total_discount > 0) || isDiscountOnCart(cart, code);
        if (!discountOk) {
          state.appliedCouponCode = null;
          state.cartPricing = null;
          return clearCheckoutDiscount().then(function () {
            setCouponError('That coupon code is not valid for this order.');
            renderCouponUI();
            updateSummary({ skipCartSync: true });
            return false;
          });
        }
      }
      updateSummary({ skipCartSync: true });
      showToast('Coupon ' + code + ' applied.');
      return true;
    }).catch(function (err) {
      state.appliedCouponCode = null;
      state.cartPricing = null;
      var msg = (err && err.description) ? err.description : ((err && err.message) ? err.message : 'Could not apply coupon to cart.');
      setCouponError(msg);
      renderCouponUI();
      updateSummary({ skipCartSync: true });
      return false;
    });
  }

  function applyManualCoupon(rawCode) {
    var code = normalizeCouponCode(rawCode);
    if (!code) {
      setCouponError('Enter a coupon code.');
      return Promise.resolve(false);
    }

    var def = getCouponDefinition(code);
    if (!def) {
      setCouponError('That coupon code is not valid.');
      return Promise.resolve(false);
    }
    if (def.type === 'multi-track') {
      setCouponError('That coupon code is not valid for this order.');
      return Promise.resolve(false);
    }

    var applyBtn = document.getElementById('orderCouponApply');
    if (applyBtn) applyBtn.disabled = true;

    return finishApplyCoupon(code).finally(function () {
      if (applyBtn) applyBtn.disabled = false;
    });
  }

  function removeCoupon() {
    state.appliedCouponCode = null;
    state.couponUserRemoved = true;
    state.cartPricing = null;
    setCouponError('');
    clearCheckoutDiscount()
      .then(function () {
        if (state.package && getVariantId()) {
          return syncWizardCartWithPricing();
        }
        return null;
      })
      .finally(function () {
        renderCouponUI();
        updateSummary({ skipCartSync: true });
        showToast('Coupon removed.');
      });
  }

  function bindCouponControls() {
    var applyBtn = document.getElementById('orderCouponApply');
    var removeBtn = document.getElementById('orderCouponRemove');
    var inputEl = document.getElementById('orderCouponInput');

    if (applyBtn && !applyBtn.dataset.bound) {
      applyBtn.dataset.bound = '1';
      applyBtn.addEventListener('click', function () {
        applyManualCoupon(inputEl ? inputEl.value : '');
      });
    }

    if (inputEl && !inputEl.dataset.bound) {
      inputEl.dataset.bound = '1';
      inputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyManualCoupon(inputEl.value);
        }
      });
    }

    if (removeBtn && !removeBtn.dataset.bound) {
      removeBtn.dataset.bound = '1';
      removeBtn.addEventListener('click', removeCoupon);
    }
  }

  function updateSummary(options) {
    if (!orderSummary) return;
    options = options || {};

    syncCouponState();
    syncSummaryTrackIndex();
    ensureSummaryLayout();
    syncSummaryStack(options.animateStack);
    renderSummaryDetails();
    renderCouponUI();

    if (!options.skipCartSync) {
      scheduleCartSync();
    }
  }

  if (songSearch) {
    songSearch.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleSearchInput();
      }
    });
    songSearch.addEventListener('input', handleSearchTyping);
    songSearch.addEventListener('paste', function (e) {
      var pasted = '';
      if (e.clipboardData) {
        pasted = e.clipboardData.getData('text') || '';
      }
      clearTimeout(searchDebounce);
      setTimeout(function () {
        var q = pasted.trim() || songSearch.value.trim();
        if (!q) return;
        if (parseSpotifyUrl(q) || q.length >= 2) {
          songSearch.value = q;
          runSpotifyLookup(q);
        }
      }, 80);
    });
  }

  if (btnFocusSearch) {
    btnFocusSearch.addEventListener('click', function () {
      if (songSearch) {
        songSearch.focus();
        songSearch.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  if (btnAddSong) {
    btnAddSong.addEventListener('click', handleSearchInput);
  }

  if (btnPromoteSongs) {
    btnPromoteSongs.addEventListener('click', function () {
      if (!state.songs.length) {
        showToast('Add at least one track before continuing.');
        return;
      }
      if (state.category && state.package) {
        goToStep(4);
      } else if (state.category) {
        goToStep(3);
      } else {
        goToStep(2);
      }
    });
  }

  if (btnRemoveExcessSongs) {
    btnRemoveExcessSongs.addEventListener('click', removeExcessSongs);
  }

  document.querySelectorAll('[data-goto]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      goToStep(parseInt(btn.dataset.goto, 10));
    });
  });

  steps.forEach(function (stepEl) {
    stepEl.addEventListener('click', function () {
      var target = parseInt(stepEl.dataset.step, 10);
      if (target === state.step) return;
      goToStep(target);
    });
  });

  if (qtyInput) {
    document.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = btn.hasAttribute('data-qty-minus') ? Math.max(1, v - 1) : Math.min(99, v + 1);
        updateSummary();
      });
    });
    qtyInput.addEventListener('change', updateSummary);
  }

  var orderForm = document.getElementById('orderForm');

  function bindAddToCartButton() {
    var btn = document.getElementById('orderAddToCartBtn');
    if (!btn || btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      submitOrderToCart(false);
    });
  }

  function ensureCheckoutActions() {
    var row = document.querySelector('.checkout-card--row');
    if (!row) return;

    var submitBtn = document.getElementById('orderSubmitBtn');
    if (!submitBtn) return;

    if (document.getElementById('orderAddToCartBtn')) {
      bindAddToCartButton();
      return;
    }

    var actions = document.createElement('div');
    actions.className = 'checkout-card__actions';

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.id = 'orderAddToCartBtn';
    addBtn.className = 'btn btn--outline btn--lg checkout-add-cart';
    addBtn.setAttribute('aria-label', 'Add to cart');
    addBtn.innerHTML = '<i class="ti ti-shopping-cart" aria-hidden="true"></i><span>Add to cart</span>';

    submitBtn.classList.remove('btn--block');
    if (submitBtn.querySelector('.ti-shopping-cart')) {
      submitBtn.innerHTML = '<i class="ti ti-arrow-right" aria-hidden="true"></i><span>Checkout</span>';
    }

    var parent = submitBtn.parentNode;
    if (parent && parent.classList.contains('checkout-card__actions')) {
      parent.insertBefore(addBtn, submitBtn);
    } else {
      parent.insertBefore(actions, submitBtn);
      actions.appendChild(addBtn);
      actions.appendChild(submitBtn);
    }

    bindAddToCartButton();
  }

  function resetCheckoutButtons() {
    var checkoutBtn = document.getElementById('orderSubmitBtn');
    var cartBtn = document.getElementById('orderAddToCartBtn');
    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.innerHTML = '<i class="ti ti-arrow-right" aria-hidden="true"></i><span>Checkout</span>';
    }
    if (cartBtn) {
      cartBtn.disabled = false;
      cartBtn.innerHTML = '<i class="ti ti-shopping-cart" aria-hidden="true"></i><span>Add to cart</span>';
    }
  }

  function submitOrderToCart(redirectToCheckout) {
    if (!validateOrderForm()) return;
    if (!canProceedToStep4()) {
      promptForSongsBeforeCheckout();
      return;
    }
    if (!state.package) {
      showToast('Please complete all steps before checkout.');
      return;
    }

    var variantId = getVariantId();
    if (!variantId) {
      var msg = 'Could not find this product in Shopify. Import products using the CSV and matching handles.';
      if (orderSubmitHelp) {
        orderSubmitHelp.textContent = msg;
        orderSubmitHelp.hidden = false;
      }
      showToast(msg);
      return;
    }

    var orderSubmitBtn = document.getElementById('orderSubmitBtn');
    var orderAddToCartBtn = document.getElementById('orderAddToCartBtn');
    if (orderSubmitBtn) orderSubmitBtn.disabled = true;
    if (orderAddToCartBtn) orderAddToCartBtn.disabled = true;
    if (orderSubmitHelp) orderSubmitHelp.hidden = true;

    if (redirectToCheckout && orderSubmitBtn) {
      orderSubmitBtn.innerHTML = '<i class="ti ti-loader"></i> Processing…';
    } else if (orderAddToCartBtn) {
      orderAddToCartBtn.innerHTML = '<i class="ti ti-loader"></i> Adding…';
    }

    var orderQty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var cartPayload = buildCartItems();
    if (cartPayload.error) {
      showToast(cartPayload.error);
      if (orderSubmitHelp) {
        orderSubmitHelp.textContent = cartPayload.error;
        orderSubmitHelp.hidden = false;
      }
      resetCheckoutButtons();
      return;
    }
    var cartItems = cartPayload.items;
    if (!cartItems.length) {
      showToast('Could not build cart items. Please try again.');
      resetCheckoutButtons();
      return;
    }

    syncWizardCartWithPricing()
      .then(function () {
        if (redirectToCheckout) {
          window.location.href = getCheckoutRedirectUrl();
          return;
        }
        resetCheckoutButtons();
        document.dispatchEvent(new CustomEvent('theme:open-cart'));
        showToast('Added to cart — review or keep shopping');
      })
      .catch(function (err) {
        resetCheckoutButtons();
        var msg = (err && err.description) ? err.description : ((err && err.message) ? err.message : 'Could not add to cart. Please try again.');
        if (orderSubmitHelp) {
          orderSubmitHelp.textContent = msg;
          orderSubmitHelp.hidden = false;
        }
        showToast(msg);
      });
  }

  if (orderForm) {
    orderForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitOrderToCart(true);
    });
  }

  ensureCheckoutActions();
  bindCouponControls();
  renderCouponUI();

  function applyOrderDeepLink() {
    var params = new URLSearchParams(window.location.search);
    var category = params.get('category');
    var packageId = params.get('package');
    var type = params.get('type');

    if (type && !category) {
      var typeMap = {
        editorial: ['editorial', 'editorial-5k'],
        algorithmic: ['algorithmic', 'basic-buzz'],
        radio: ['editorial', 'radio'],
        meta: ['social', 'meta'],
        'algo-playlist': ['algorithmic', 'basic-buzz'],
        playlist: ['playlist', 'starter']
      };
      if (typeMap[type]) {
        category = typeMap[type][0];
        packageId = typeMap[type][1];
      }
    }

    var rawCategory = params.get('category');
    category = resolveOrderCategory(category, packageId);
    packageId = resolveOrderPackage(rawCategory, packageId);

    if (category && getPackagesForCategory(category).length) {
      state.category = category;
      renderCategories();
    }

    if (packageId && state.category) {
      state.package = getPackagesForCategory(state.category).find(function (p) {
        return p.id === packageId;
      }) || null;
      applyCanonicalPackagePrice(state.package);
    }

    if (!state.category || !state.package) {
      applyDefaultSelection();
    } else {
      refreshOrderAfterSelectionChange({ rerenderCategories: false });
    }

    var songsParam = params.get('songs');
    var isEdit = params.get('edit') === '1';
    if (songsParam && state.songs.length === 0) {
      var urls = songsParam.split('|').filter(Boolean);
      var spotifyApi = window.spotifyClient || (window.SpotifyClient ? new window.SpotifyClient() : null);
      urls.forEach(function (url) {
        if (!spotifyApi) {
          addSong({ title: 'Spotify Track', artist: '', url: url, art: '' });
          return;
        }
        spotifyApi.resolve(url).then(function (result) {
          if (result.track) addSong(result.track);
          else if (result.tracks && result.tracks.length) addSong(result.tracks[0]);
          else addSong({ title: 'Spotify Track', artist: '', url: url, art: '' });
        }).catch(function () {
          addSong({ title: 'Spotify Track', artist: '', url: url, art: '' });
        });
      });
    }

    if (isEdit && state.package) {
      setTimeout(function () {
        if (!canProceedToStep4()) {
          goToStep(1);
          return;
        }
        goToStep(4);
      }, songsParam ? 800 : 0);
    }
  }

  renderCategories();
  applyOrderDeepLink();
  renderSongs();
  updatePromoteBtn();
  updateSongLimitHint();
  updateProgressBar();
  updateSummaryPanelState();
  updateSummary();

  if (orderSummary) {
    orderSummary.addEventListener('click', function (e) {
      if (e.target.closest('[data-change-plan]')) {
        e.preventDefault();
        goToStep(2);
        return;
      }
      var dotBtn = e.target.closest('[data-summary-dot]');
      if (dotBtn) {
        setSummaryTrack(parseInt(dotBtn.dataset.summaryDot, 10), true);
        return;
      }
      var nextBtn = e.target.closest('[data-summary-next]');
      if (!nextBtn || state.songs.length < 2) return;
      setSummaryTrack(summaryTrackIndex + 1, true);
    });
  }

  if (songSearch) songSearch.focus();
  window.addEventListener('resize', updateSummaryPanelState);
})();
